<template>
  <div>
    <div class="vi-header">
      <div id="headerweb" class="web d-flex align-items-center wow web-fadeIn">
        <div class="container-fluid d-flex align-items-center">
          <div class="web-logo">
            <h1>
              <router-link to="/admin-panel"
                ><svg
                  width="56px"
                  height="65px"
                  style="color:#2954a2"
                  viewBox="0 0 61 65"
                  version="1.1"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="Group-3-Copy-2" transform="translate(0.5 0.5)">
                    <path
                      d="M0.0444173 0.294993L0.0336952 0.00123215L2.36226 0.000547909Q2.45506 0.000520639 2.54744 0.00937808Q2.63982 0.0182355 2.73093 0.0358963Q2.82204 0.0535571 2.91104 0.0798589Q3.00003 0.106161 3.0861 0.140862Q3.17218 0.175564 3.25453 0.218346Q3.33688 0.261128 3.41476 0.311597Q3.49264 0.362067 3.56533 0.419761Q3.63802 0.477455 3.70486 0.541843Q3.77169 0.60623 3.83205 0.676721Q3.89241 0.747211 3.94575 0.823157Q3.99908 0.899102 4.0449 0.979805Q4.09072 1.06051 4.12861 1.14523Q4.16649 1.22994 4.19609 1.3179Q4.22569 1.40586 4.24673 1.49624Q4.26778 1.58663 4.28007 1.67862Q4.29236 1.7706 4.29579 1.86334L4.29587 1.86533Q4.29922 1.95589 4.29351 2.04633Q4.2878 2.13678 4.27309 2.2262Q4.25838 2.31562 4.23482 2.40312Q4.21126 2.49063 4.17908 2.57535Q4.1469 2.66006 4.10643 2.74114Q4.06595 2.82222 4.01758 2.89886Q3.96922 2.9755 3.91344 3.04692Q3.85767 3.11834 3.79504 3.18384Q3.73241 3.24934 3.66356 3.30826Q3.5947 3.36718 3.52031 3.41893Q3.44592 3.47069 3.36673 3.51475Q3.28755 3.55882 3.20436 3.59476Q3.12117 3.6307 3.03481 3.65816Q2.94844 3.68562 2.85977 3.70432Q2.7711 3.72302 2.681 3.73277Q2.59091 3.74253 2.50029 3.74324L0 3.76286L0.0487269 3.59859Q0.0973663 3.43461 0.0945705 3.26359L0.0486721 0.456024Q0.0473557 0.375496 0.044418 0.29501L0.0444173 0.294993Z"
                      transform="matrix(0.8660256 0.49999964 -0.49999964 0.8660256 15.89679 52.151062)"
                      id="Rectangle-4"
                      fill="#2954a2"
                      fill-rule="evenodd"
                      stroke="none"
                    />
                    <path
                      d="M0.0444209 0.295069L0.033699 0.00123024L2.36226 0.000547061Q2.45506 0.000519833 2.54744 0.00937731Q2.63982 0.0182348 2.73093 0.0358956Q2.82204 0.0535564 2.91104 0.0798583Q3.00003 0.10616 3.08611 0.140862Q3.17218 0.175563 3.25453 0.218345Q3.33688 0.261127 3.41476 0.311597Q3.49264 0.362067 3.56533 0.41976Q3.63802 0.477454 3.70486 0.541842Q3.77169 0.60623 3.83205 0.67672Q3.89241 0.747211 3.94575 0.823156Q3.99908 0.899102 4.04491 0.979804Q4.09073 1.06051 4.12861 1.14523Q4.16649 1.22994 4.19609 1.3179Q4.22569 1.40586 4.24674 1.49624Q4.26778 1.58663 4.28007 1.67861Q4.29236 1.7706 4.29579 1.86334L4.29587 1.86533Q4.29922 1.95589 4.29351 2.04633Q4.2878 2.13678 4.27309 2.2262Q4.25839 2.31562 4.23483 2.40312Q4.21126 2.49063 4.17909 2.57535Q4.14691 2.66006 4.10643 2.74114Q4.06595 2.82222 4.01759 2.89886Q3.96922 2.97549 3.91344 3.04692Q3.85767 3.11834 3.79504 3.18384Q3.73241 3.24934 3.66356 3.30826Q3.59471 3.36718 3.52031 3.41893Q3.44592 3.47069 3.36674 3.51475Q3.28755 3.55882 3.20436 3.59476Q3.12117 3.6307 3.03481 3.65816Q2.94845 3.68562 2.85978 3.70432Q2.7711 3.72302 2.68101 3.73277Q2.59091 3.74253 2.50029 3.74324L0 3.76286L0.0487307 3.59858Q0.097374 3.4346 0.0945777 3.26358L0.0486715 0.455973Q0.0473556 0.375496 0.0444207 0.295062L0.0444209 0.295069Z"
                      transform="matrix(-0.8660258 0.49999973 0.49999973 0.8660258 44.081818 52.151062)"
                      id="Rectangle-4-Copy"
                      fill="#2954a2"
                      fill-rule="evenodd"
                      stroke="none"
                    />
                    <path
                      d="M0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30C60 41.6378 53.3734 51.7278 43.6875 56.7027L43.6875 52.4034C51.2224 47.7901 56.25 39.4822 56.25 30C56.25 15.5025 44.4975 3.75 30 3.75C15.5025 3.75 3.75 15.5025 3.75 30C3.75 39.4822 8.7776 47.7901 16.3125 52.4034L16.3125 56.7027C6.62664 51.7278 0 41.6378 0 30Z"
                      id="Group-Difference"
                      fill="#2954a2"
                      fill-rule="evenodd"
                      stroke="none"
                    />
                    <g id="lens" transform="translate(23.625 13.875)">
                      <path
                        d="M1.874 0L1.876 0Q1.96806 0 2.05968 0.00902382Q2.1513 0.0180476 2.2416 0.0360084Q2.33189 0.0539691 2.41999 0.0806938Q2.50809 0.107418 2.59315 0.14265Q2.6782 0.177881 2.7594 0.22128Q2.84059 0.264678 2.91714 0.315826Q2.99369 0.366974 3.06485 0.425378Q3.13602 0.483783 3.20112 0.548882Q3.26622 0.613981 3.32462 0.685147Q3.38303 0.756313 3.43417 0.832861Q3.48532 0.90941 3.52872 0.990603Q3.57212 1.0718 3.60735 1.15685Q3.64258 1.24191 3.66931 1.33001Q3.69603 1.41811 3.71399 1.5084Q3.73195 1.5987 3.74098 1.69032Q3.75 1.78194 3.75 1.874L3.75 10.876Q3.75 10.9681 3.74098 11.0597Q3.73195 11.1513 3.71399 11.2416Q3.69603 11.3319 3.66931 11.42Q3.64258 11.5081 3.60735 11.5931Q3.57212 11.6782 3.52872 11.7594Q3.48532 11.8406 3.43417 11.9171Q3.38303 11.9937 3.32462 12.0649Q3.26622 12.136 3.20112 12.2011Q3.13602 12.2662 3.06485 12.3246Q2.99369 12.383 2.91714 12.4342Q2.84059 12.4853 2.7594 12.5287Q2.67821 12.5721 2.59315 12.6073Q2.50809 12.6426 2.41999 12.6693Q2.3319 12.696 2.2416 12.714Q2.15131 12.732 2.05969 12.741Q1.96806 12.75 1.876 12.75L1.874 12.75Q1.78194 12.75 1.69032 12.741Q1.5987 12.732 1.5084 12.714Q1.41811 12.696 1.33001 12.6693Q1.24191 12.6426 1.15685 12.6074Q1.0718 12.5721 0.990604 12.5287Q0.909411 12.4853 0.832862 12.4342Q0.756314 12.383 0.685148 12.3246Q0.613982 12.2662 0.548883 12.2011Q0.483784 12.136 0.42538 12.0649Q0.366975 11.9937 0.315827 11.9171Q0.264679 11.8406 0.221281 11.7594Q0.177882 11.6782 0.142651 11.5931Q0.10742 11.5081 0.0806951 11.42Q0.0539704 11.3319 0.0360096 11.2416Q0.0180489 11.1513 0.00902506 11.0597Q1.23058e-06 10.9681 1.22025e-06 10.876L2.10257e-07 1.874Q1.99928e-07 1.78194 0.00902401 1.69032Q0.0180478 1.5987 0.0360086 1.5084Q0.0539693 1.41811 0.080694 1.33001Q0.107419 1.24191 0.14265 1.15685Q0.177881 1.0718 0.22128 0.990603Q0.264678 0.90941 0.315826 0.832861Q0.366974 0.756313 0.425379 0.685147Q0.483783 0.613981 0.548882 0.548882Q0.613981 0.483783 0.685147 0.425378Q0.756313 0.366974 0.832862 0.315826Q0.90941 0.264678 0.990603 0.22128Q1.0718 0.177881 1.15685 0.14265Q1.24191 0.107419 1.33001 0.0806938Q1.41811 0.0539691 1.5084 0.0360084Q1.5987 0.0180476 1.69032 0.00902382Q1.78194 0 1.874 0L1.874 0Z"
                        transform="matrix(0.57357705 -0.81915164 0.81915164 0.57357705 12.240692 12.684998)"
                        id="Rectangle-3"
                        fill="#2954a2"
                        fill-rule="evenodd"
                        stroke="none"
                      />
                      <path
                        d="M6.75 0C3.02208 0 0 3.02208 0 6.75C0 10.4779 3.02208 13.5 6.75 13.5C10.4779 13.5 13.5 10.4779 13.5 6.75C13.5 3.02208 10.4779 0 6.75 0ZM6.75 2.25C4.26472 2.25 2.25 4.26472 2.25 6.75C2.25 9.23528 4.26472 11.25 6.75 11.25C9.23528 11.25 11.25 9.23528 11.25 6.75C11.25 4.26472 9.23528 2.25 6.75 2.25Z"
                        id="Ellipse-Difference"
                        fill="#2954a2"
                        fill-rule="evenodd"
                        stroke="none"
                      />
                    </g>
                    <g id="v" transform="translate(12.868317 20.411804)">
                      <path
                        d="M1.874 0L1.876 0Q1.96806 0 2.05969 0.00902382Q2.15131 0.0180476 2.2416 0.0360084Q2.3319 0.0539691 2.41999 0.0806938Q2.50809 0.107418 2.59315 0.14265Q2.67821 0.177881 2.7594 0.22128Q2.84059 0.264678 2.91714 0.315826Q2.99369 0.366974 3.06485 0.425378Q3.13602 0.483783 3.20112 0.548882Q3.26622 0.613981 3.32462 0.685147Q3.38303 0.756313 3.43418 0.832861Q3.48532 0.909409 3.52872 0.990602Q3.57212 1.0718 3.60735 1.15685Q3.64258 1.24191 3.66931 1.33001Q3.69603 1.41811 3.71399 1.5084Q3.73195 1.5987 3.74098 1.69032Q3.75 1.78194 3.75 1.874L3.75 31.126Q3.75 31.2181 3.74098 31.3097Q3.73195 31.4013 3.71399 31.4916Q3.69603 31.5819 3.66931 31.67Q3.64258 31.7581 3.60735 31.8432Q3.57212 31.9282 3.52872 32.0094Q3.48532 32.0906 3.43417 32.1671Q3.38303 32.2437 3.32462 32.3149Q3.26622 32.386 3.20112 32.4511Q3.13602 32.5162 3.06485 32.5746Q2.99369 32.633 2.91714 32.6842Q2.84059 32.7353 2.7594 32.7787Q2.6782 32.8221 2.59315 32.8574Q2.50809 32.8926 2.41999 32.9193Q2.33189 32.946 2.2416 32.964Q2.1513 32.982 2.05968 32.991Q1.96806 33 1.876 33L1.874 33Q1.78194 33 1.69032 32.991Q1.59869 32.982 1.5084 32.964Q1.41811 32.946 1.33001 32.9193Q1.24191 32.8926 1.15685 32.8574Q1.07179 32.8221 0.990602 32.7787Q0.909409 32.7353 0.832861 32.6842Q0.756313 32.633 0.685147 32.5746Q0.61398 32.5162 0.548882 32.4511Q0.483783 32.386 0.425378 32.3149Q0.366974 32.2437 0.315826 32.1671Q0.264678 32.0906 0.221279 32.0094Q0.177881 31.9282 0.14265 31.8432Q0.107418 31.7581 0.0806938 31.67Q0.0539691 31.5819 0.0360084 31.4916Q0.0180477 31.4013 0.00902387 31.3097Q5.14965e-08 31.2181 5.41571e-08 31.126L8.99517e-07 1.874Q9.02178e-07 1.78194 0.00902473 1.69032Q0.0180486 1.5987 0.0360093 1.5084Q0.05397 1.41811 0.0806947 1.33001Q0.107419 1.24191 0.142651 1.15685Q0.177882 1.0718 0.22128 0.990602Q0.264679 0.90941 0.315827 0.832861Q0.366975 0.756313 0.425379 0.685147Q0.483784 0.613981 0.548883 0.548882Q0.613982 0.483783 0.685148 0.425378Q0.756314 0.366974 0.832862 0.315826Q0.90941 0.264678 0.990603 0.22128Q1.0718 0.177881 1.15685 0.14265Q1.24191 0.107418 1.33001 0.0806938Q1.41811 0.0539691 1.5084 0.0360084Q1.5987 0.0180476 1.69032 0.00902382Q1.78194 0 1.874 0L1.874 0Z"
                        transform="matrix(-0.8660258 0.49999973 0.49999973 0.8660258 3.2475872 0.5489497)"
                        id="Rectangle-2-Copy"
                        fill="#2954a2"
                        fill-rule="evenodd"
                        stroke="none"
                      />
                      <path
                        d="M1.874 0L1.876 0Q1.96806 0 2.05968 0.00902382Q2.1513 0.0180476 2.2416 0.0360084Q2.33189 0.0539691 2.41999 0.0806938Q2.50809 0.107418 2.59315 0.14265Q2.6782 0.177881 2.7594 0.22128Q2.84059 0.264678 2.91714 0.315826Q2.99369 0.366974 3.06485 0.425378Q3.13602 0.483783 3.20112 0.548882Q3.26622 0.613981 3.32462 0.685147Q3.38303 0.756313 3.43417 0.832861Q3.48532 0.909409 3.52872 0.990602Q3.57212 1.0718 3.60735 1.15685Q3.64258 1.24191 3.66931 1.33001Q3.69603 1.41811 3.71399 1.5084Q3.73195 1.5987 3.74098 1.69032Q3.75 1.78194 3.75 1.874L3.75 31.126Q3.75 31.2181 3.74098 31.3097Q3.73195 31.4013 3.71399 31.4916Q3.69603 31.5819 3.66931 31.67Q3.64258 31.7581 3.60735 31.8432Q3.57212 31.9282 3.52872 32.0094Q3.48532 32.0906 3.43417 32.1671Q3.38303 32.2437 3.32462 32.3149Q3.26622 32.386 3.20112 32.4511Q3.13602 32.5162 3.06485 32.5746Q2.99369 32.633 2.91714 32.6842Q2.84059 32.7353 2.7594 32.7787Q2.6782 32.8221 2.59315 32.8574Q2.50809 32.8926 2.41999 32.9193Q2.33189 32.946 2.2416 32.964Q2.1513 32.982 2.05968 32.991Q1.96806 33 1.876 33L1.874 33Q1.78194 33 1.69032 32.991Q1.5987 32.982 1.5084 32.964Q1.41811 32.946 1.33001 32.9193Q1.24191 32.8926 1.15685 32.8574Q1.0718 32.8221 0.990602 32.7787Q0.90941 32.7353 0.832861 32.6842Q0.756313 32.633 0.685147 32.5746Q0.613981 32.5162 0.548882 32.4511Q0.483783 32.386 0.425378 32.3149Q0.366974 32.2437 0.315826 32.1671Q0.264678 32.0906 0.22128 32.0094Q0.177881 31.9282 0.14265 31.8432Q0.107418 31.7581 0.0806938 31.67Q0.0539691 31.5819 0.0360084 31.4916Q0.0180476 31.4013 0.00902382 31.3097Q0 31.2181 0 31.126L0 1.874Q0 1.78194 0.00902382 1.69032Q0.0180476 1.5987 0.0360084 1.5084Q0.0539691 1.41811 0.0806938 1.33001Q0.107418 1.24191 0.14265 1.15685Q0.177881 1.0718 0.22128 0.990602Q0.264678 0.90941 0.315826 0.832861Q0.366974 0.756313 0.425378 0.685147Q0.483783 0.613981 0.548882 0.548882Q0.613981 0.483783 0.685147 0.425378Q0.756313 0.366974 0.832861 0.315826Q0.909409 0.264678 0.990602 0.22128Q1.0718 0.177881 1.15685 0.14265Q1.24191 0.107418 1.33001 0.0806938Q1.41811 0.0539691 1.5084 0.0360084Q1.5987 0.0180476 1.69032 0.00902382Q1.78194 0 1.874 0L1.874 0Z"
                        transform="matrix(0.8660258 0.49999973 -0.49999973 0.8660258 31.574982 0.5507202)"
                        id="Rectangle-2-Copy-2"
                        fill="#2954a2"
                        fill-rule="evenodd"
                        stroke="none"
                      />
                    </g>
                  </g>
                </svg>
                <span
                  class="ml-2 mt-1"
                  style="color:#2954a2;font-size:2rem;font-weight:600"
                  >Vidhyaan</span
                ></router-link
              >
            </h1>
          </div>
          <div class="sidebar" id="mySidebar">
            <ul>
              <!-- <li>
                <a href="javascript:void(0)" @click="redirectRoute('/')"
                  >Home</a
                >
              </li> -->
              <li>
                <a @click="enableSchoolView" style="color: #2954a2;">Account</a>
              </li>
              <li>
                <a @click="enableTermsAndConditionsView" style="color: #2954a2;"
                  >Terms & Conditions</a
                >
              </li>
              <li>
                <a  @click="enableFeatureRequestView" style="color: #2954a2;"
                  >Feature Request</a
                >
              </li>
            </ul>
          </div>

          <div class="web-header-web-social-links">
            <button
              class="btn web-custbtn web-lgd web-rounded-xl h-100 btn-3"
              id="regbtnid"
              style="visibility: hidden;"
            >
              <span><b-icon icon="person" style="height: 15px"></b-icon></span
              >Register
            </button>
            <button
              class="btn web-custbtn web-lgd web-rounded-xl h-100 btn-3"
              id="regbtnid"
              @click.prevent="logout"
            >
              <span><b-icon icon="person" style="height: 15px"></b-icon></span
              >Logout
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="v-school-list" v-if="schoolView">
      <main v-if="accountList">
        <div class="web-innerpagecont py-3 pl-3 pr-3">
          <div class="container-fluid">
            
                <div class="row web-row-flex">
                  <div class="col-lg-12">
                    <div class="widjet">
                      <div class="widjethdr dispflex">
                        <div style="width: auto">
                          <span
                            class="iconsect blubg"
                         
                            ><i class="far fa-calendar-alt"></i
                          ></span>
                          <h1>View Schools List ({{ accountList.length }})</h1>
                        </div>
                        <div style="margin-top:10px">
                          <input
                            type="text"
                            v-model="searchWords"
                            placeholder="Search School"
                          />
                        </div>
                        <div class="mt-1">
                          <!-- <button class="btn gry_bg mpopup"
                          @click.prevent="navToMeeting">
                            <i class="fas fa-calendar-plus"></i>
                          </button> -->
                          <!-- &nbsp; -->
                          <button
                            class="btn gry_bg mpopup"
                            @click.prevent="openSchoolCreationModal"
                          >
                            <i class="fas fa-calendar-plus"></i>
                          </button>
                        </div>
                      </div>
                      <!-- <div id="meet"></div> -->
                      <div class="widjetcontent">
                        <div>
                          <div class="restable">
                            <div class="resrow resheader">
                              <div class="cell">
                                School Name
                              </div>
                              <div class="cell" >
                                Affilliate Id
                              </div>
                               <div class="cell" >
                                Mail Id
                              </div>
                              <div class="cell">State</div>
                              <div class="cell">
                                Subscription Type
                              </div>
                              <div class="cell">
                                Verified ?
                              </div>
                              <!-- <div class="cell" >
                                Status
                              </div> -->
                              <!-- <div class="cell">
                                Enrolled Date
                              </div> -->

                              <div class="cell" >
                                Grant Login
                              </div>
                              <div class="cell" >Action</div>
                            </div>

                            <div
                              class="resrow"
                              v-for="(item, index) in accountList"
                              :key="index"
                            >
                              <div class="cell" data-title="School Name">
                                {{ item.accountName }}
                              </div>
                              <div class="cell" data-title="Email">
                                {{ item.affilliateId }}
                              </div>
                              <div class="cell" data-title="State">
                                {{ item.email }}
                              </div>
                              <div class="cell" data-title="State">
                                {{ item.state }}
                              </div>

                              <div class="cell" data-title="Is Payment ?">
                                <span v-if="item.version == 'freeVersion'">
                                  Free
                                </span>
                                <span v-else> Paid </span>
                              </div>
                              <div class="cell" data-title="Is Verified ?">
                                <span v-if="item.isVerified == true">
                                  Yes
                                </span>
                                <span v-else> No </span>
                              </div>
                             
                              <!-- <div class="cell" data-title="Enrolled Date">
                                {{ new Date(item.createdDate) | dateFormat }}
                              </div> -->

                              <div class="cell" data-title="Grand Login">
                                <!-- <button
                                  style="padding: 0.375rem 0.75rem; line-height: 1.5;"
                                  class="web-custbtn web-lgd web-rounded-xl h-100 btn-3"
                                  id="regbtnid"
                                  v-if="item.isGrandLoginActive == true"
                                  @click="
                                    redirectCustomRoute(
                                      `/grand-login/validate?accountId=${item._id}`
                                    )
                                  "
                                >
                                  Login
                                </button> -->
                                <a style="font-size: smaller;
    color: #3737ed;
    font-weight: bold;" @click.prevent="checkGrandLogin(item._id)">Check</a>
                              </div>
                              <div class="cell" data-title="Action">
                                  <b-dropdown id="dropdown-1" text="" right  style="margin-right:3px">
                                    <b-dropdown-item @click.prevent="enableWriteView(item._id)">Edit</b-dropdown-item>

                                    <b-dropdown-item @click.prevent="enableReadView(item._id)">View</b-dropdown-item>
                                     <b-dropdown-item  @click.prevent="resetPassword(item._id)">Resend Invite</b-dropdown-item>
                                     <b-dropdown-item @click.prevent="openApproveModel(item._id,item.email)">Approve</b-dropdown-item>
                                     <b-dropdown-item @click.prevent="openRejectionModal(item._id,item.email)">Reject</b-dropdown-item>
                                     <b-dropdown-item @click.prevent="openReviewModal(item._id)"> RERA</b-dropdown-item>
                                     <b-dropdown-item  :disabled="item.version != 'freeVersion'"  @click.prevent="deleteCustomerAndAccount(item.customerId,item._id)">Delete</b-dropdown-item>


                                </b-dropdown>

                              
                                <!-- <button
                                  @click.prevent="enableWriteView(item._id)"
                                  class="btn round red tooltipt"
                                >
                                  <i class="fas fa-edit"></i
                                  ><span class="tooltiptext">Edit</span>
                                </button>
                               
                                <button :disabled="item.version != 'freeVersion'" class="btn round red tooltipt" @click="deleteCustomerAndAccount(item.customerId,item._id)">
                                <i class="far fa-trash-alt"></i>
                                <span class="tooltiptext">Delete</span>
                              </button> -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
             
          </div>
        </div>
      </main>
      <div class="vi-not-fount d-flex justify-content-center" v-else>
        <img
          src="../../assets/img/404.svg"
          alt="404"
          style="height: 500px; padding: 100px"
        />
      </div>
      <div class="text-center mt-4" v-if="accountList.length > 0">
        <div class="pagination" id="pagination">
          <a
            :style="currentPageNumber === 1 ? 'pointer-events: none;' : ''"
            @click="goToPreviousPage"
            >&laquo;</a
          >
          <!-- class="active"  -->
          <a
            v-for="(item, index) in lastPageNumber"
            :key="index"
            v-on:click="selected = item"
            v-bind:class="{ active: selected == item }"
            @click="navToSelectedPage(item)"
            >{{ item }}</a
          >
          <a
            :style="
              currentPageNumber === lastPageNumber
                ? 'pointer-events: none;'
                : ''
            "
            @click="goToNextPage"
            >&raquo;</a
          >
        </div>
      </div>
    </div>

    <div class="v-school-list" v-if="termsAndConditionsView">
      <main>
        <div class="web-innerpagecont py-3 pl-3 pr-3">
          <div class="container-fluid">
            <div class="row web-row-flex">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="widjet">
                      <div class="widjethdr dispflex">
                        <div style="width: auto">
                          <span
                            class="iconsect blubg"
                           
                            ><i class="far fa-calendar-alt"></i
                          ></span>
                          <h1 style="display: flex;">
                            <div>
                              View Schools List (5)
                            </div>
                          </h1>
                        </div>
                        <div>
                          <button class="btn gry_bg mpopup">
                            <i class="fas fa-calendar-plus"></i>
                          </button>
                        </div>
                      </div>
                      <div class="photobrd">
                        <div
                          class="card card-block p-3 w-100 mx-auto custbtn text-center uploadphoto"
                        >
                          <!-- <i class="fa fa-upload fa-2x" aria-hidden="true"></i>
                          Upload Photo -->
                          <input
                            type="file"
                            ref="schoolImageFile"
                            name="schoolImageFile"
                            accept="image/*"
                            @change="
                              updateFile('schoolImage', 'schoolImageFile')
                            "
                          />
                        </div>
                        <!-- <div
                          class="card card-block p-3 w-100 mx-auto custbtn text-center uploadphoto"
                        >
                          <input
                            type="file"
                            label="Excel Import/Export"
                            ref="importFile"
                            name="importFile"
                            @change="
                              updateCSVFile('importFile')
                            "
                          />
                        </div> -->
                      </div>
                      <div class="widjetcontent">
                        <div class="restable">
                          <div class="resrow resheader">
                            <div class="cell" style="width: 23%;">
                              Name
                            </div>
                            <div class="cell" style="width: 8%;">
                              Uploaded Date
                            </div>
                            <div class="cell" style="width: 8%;">
                              View
                            </div>
                          </div>

                          <div
                            class="resrow"
                            v-for="(term, index) in termsAndConditionsList"
                            :key="index"
                          >
                            <div class="cell" data-title="School Name">
                              {{ term.name }}
                            </div>
                            <div class="cell" data-title="Uploaded Date">
                              {{ term.createdDate }}
                            </div>
                            <div class="cell" data-title="Image">
                              <a :href="term.image.path" target="_blank"
                                >Click here to download!</a
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
     <div class="v-school-list" v-if="featureRequestView">
     <div class="row mt-2">
        <div class="col-lg-12">
          <div class="widjet">
           
            <div class="p-3 widjetcontent">
              <div class="tabs" style="height: 2%; background: none">
                
                 <input checked="checked"
                  type="radio"
                  name="tabs"
                  id="newtab"
                  
                />
                <label for="newtab">New [{{ newFeatureList.length }}]</label>
                <div class="tab">
                  <div class="widjetcontent">
                        <div class="tbllist mt-1" style="height: 450px;">
                          <div class="restable">
                            <div class="resrow resheader">
                              <div class="cell">
                                Title
                              </div>
                              <div class="cell" >
                                Status
                              </div>
                               <div class="cell" >
                                Email
                              </div>
                              <div class="cell">Views</div>
                              <div class="cell">
                                Priority
                              </div>
                             
                              <div class="cell">
                                Submit Date
                              </div>

                             
                              <div class="cell" >Action</div>
                            </div>

                            <div
                              class="resrow"
                              v-for="(item, index) in newFeatureList"
                              :key="index"
                            >
                              <div class="cell" data-title="School Name">
                                {{ item.title }}
                              </div>
                              <div class="cell" data-title="Email">
                                {{ item.status }}
                              </div>
                              <div class="cell" data-title="State">
                                {{ item.email }}
                              </div>
                              <div class="cell" data-title="State">
                                {{ item.viewCount }}
                              </div>
                               <div class="cell" data-title="State">
                                {{ item.stage }}
                              </div>

                             
                              <div class="cell" data-title="Enrolled Date">
                                {{ new Date(item.createdDate) | dateFormat }}
                              </div>

                              
                              <div class="cell" data-title="Action">
                                  <b-dropdown id="dropdown-1" text="" right  style="margin-right:3px">
                                     <b-dropdown-item >Approve</b-dropdown-item>
                                     <b-dropdown-item >Reject</b-dropdown-item>

                                </b-dropdown>

                              
                                <button @click="viewIdea(item._id,item.viewCount,index)"
                                  class="btn round red tooltipt"
                                >
                                  <i class="fas fa-eye"></i
                                  ><span class="tooltiptext">View</span>
                                </button>
                               
                               
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                </div>
                <input 
                  type="radio"
                  name="tabs"
                  id="academictab"
                  
                />
                <label for="academictab">UNDER CONSIDERATION [{{ underConsiderationFeatureList.length }}]</label>
                <div class="tab">
                  <div class="widjetcontent">
                        <div class="tbllist mt-1" style="height: 450px;">
                          <div class="restable">
                            <div class="resrow resheader">
                              <div class="cell">
                                Title
                              </div>
                              <div class="cell" >
                                Status
                              </div>
                               <div class="cell" >
                                Email
                              </div>
                              <div class="cell">Views</div>
                              <div class="cell">
                                Priority
                              </div>
                             
                              <div class="cell">
                                Submit Date
                              </div>

                             
                              <div class="cell" >Action</div>
                            </div>

                            <div
                              class="resrow"
                              v-for="(item, index) in underConsiderationFeatureList"
                              :key="index"
                            >
                              <div class="cell" data-title="School Name">
                                {{ item.title }}
                              </div>
                              <div class="cell" data-title="Email">
                                {{ item.status }}
                              </div>
                              <div class="cell" data-title="State">
                                {{ item.email }}
                              </div>
                              <div class="cell" data-title="State">
                                {{ item.viewCount }}
                              </div>
                               <div class="cell" data-title="State">
                                {{ item.stage }}
                              </div>

                             
                              <div class="cell" data-title="Enrolled Date">
                                {{ new Date(item.createdDate) | dateFormat }}
                              </div>

                              
                              <div class="cell" data-title="Action">
                                  <b-dropdown id="dropdown-1" text="" right  style="margin-right:3px">
                                     <b-dropdown-item >Approve</b-dropdown-item>
                                     <b-dropdown-item >Reject</b-dropdown-item>

                                </b-dropdown>

                              
                                <button @click="viewIdea(item._id,item.viewCount,index)"
                                  class="btn round red tooltipt"
                                >
                                  <i class="fas fa-eye"></i
                                  ><span class="tooltiptext">View</span>
                                </button>
                               
                               
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                </div>
                
                <input type="radio" name="tabs" id="departtab"  />
                <label for="departtab">PLANNED [{{ plannedFeatureList.length }}]</label>
                <div class="tab">
                   
                </div>
                <input
                  type="radio"
                  name="tabs"
                  id="grandlogintab"
                />
                <label for="grandlogintab">IN PROGRESS [{{ inProgressFeatureList.length }}]</label>

                <div class="tab">
                  
                </div>
                 <input
                  type="radio"
                  name="tabs"
                  id="lanchedtab"
                />
                <label for="lanchedtab">LAUNCHED [{{ lanuchedFeatureList.length }}]</label>

                <div class="tab">
                 
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
     
    </div>

    <b-modal id="modalOne" class="modal">
      <button style="border:0;background:transparent;position:absolute;top:10px;right:10px;"
                    type="submit"
                    @click.prevent="closePopUp"
                  >
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </button>
      <div id="app">
        <ul class="nav nav-tabs nav-justified">
          <li class="nav-item">
            <a
              class="nav-link pl-3 pr-3"
              @click.prevent="setActive('schoolInfo')"
              :class="{ active: isActive('schoolInfo') }"
              href="#schooschoolInfolInfo"
              >School Info</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link pl-3 pr-3"
              @click.prevent="setActive('plan')"
              :class="{ active: isActive('plan') }"
              href="#plan"
              >Plan Details</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link pl-3 pr-3"
              @click.prevent="setActive('rating')"
              :class="{ active: isActive('rating') }"
              href="#rating"
              >Ratings & Reviews</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link pl-3 pr-3"
              @click.prevent="setActive('admission')"
              :class="{ active: isActive('admission') }"
              href="#admission"
              >Admission Details</a
            >
          </li>
        </ul>
        <div class="tab-content py-3" id="myTabContent">
          <div
            class="tab-pane fade"
            :class="{ 'active show': isActive('schoolInfo') }"
            id="schoolInfo"
          >
            <div class="widjet" v-if="schoolDetails">
              <div class="p-3 mt-3 widjetcontent">
                <form
                      data-vv-scope="schOverview"
                      id="schOverview"
                       accept-charset="utf-8"
                >
                  <div
                    class="has-float-label "
                    v-if="schoolDetails.image && schoolDetails.image.path"
                  >
                    <div class="schlogo">
                      <img
                        v-if="schoolDetails.image && schoolDetails.image.path"
                        :src="schoolDetails.image.path"
                        alt="Avatar"
                        class="mt-3"
                        width="110"
                        height="110"
                      />
                      <!-- @click.prevent="openSchoolImage(schoolDetails.image.path)" -->
                      <label for="ptmbnid"
                        >School Logo<span class="required">*</span></label
                      >
                      <div class="upldIcon">
                        <i class="fas fa-school"></i>
                        <input
                          type="file"
                          ref="schoolImagechangeFile"
                          name="schoolImagechangeFile"
                          accept="image/*"
                          @change="
                            updateSchoolLogo(
                              'schoolImage',
                              'schoolImagechangeFile'
                            )
                          "
                        />
                      </div>
                    </div>
                  </div>
                  <div class="" v-else>
                    <div class="schdp">
                      <i class="fas fa-school"></i>
                      <input
                        class="schdpupload"
                        type="file"
                        ref="schoolImageFile"
                        name="schoolImageFile"
                        accept="image/*"
                        @change="
                          updateSchoolLogo('schoolImage', 'schoolImageFile')
                        "
                      />
                    </div>
                    <div>
                      Upload School Logo
                    </div>
                  </div>
                  <div>
                        <label
                          style="margin: 0"
                          for="accordiongroup-1"
                          class="blutitle accordion-label"
                        >
                          Basic Details
                        </label>
                        <div class="form-row">
                          <div
                            class="form-group input-group col-md-6 pr-md-3 mt-3"
                          >
                            <span class="has-float-label">
                              <input
                                type="text"
                                name="schname"
                                v-validate="'required'"
                                v-model="schoolDetails.accountName"
                                class="form-control form-input"
                                id="schnameid"
                                :disabled="isEdit"
                                placeholder="School Name"
                              />
                              <label
                                v-if="errors.first('schOverview.schname')"
                                class="vi-error"
                                style="top:-1em"
                                >School Name is required</label
                              >
                              <label for="schnameid" v-else
                                >School Name
                                <span class="required">*</span></label
                              >
                            </span>
                          </div>
                          <div class="form-group input-group col-md-6 mt-3">
                            <span class="has-float-label">
                              <input
                                type="text"
                                name="afname"
                                @focusout="checkAffilliateId"
                                v-validate="'required'"
                                :disabled="isEdit"
                                v-model="schoolDetails.affilliateId"
                                class="form-control form-input"
                                id="afid"
                                placeholder="Affiliate ID"
                              />
                              <label
                                v-if="
                                  errors.first('schOverview.afname') ||
                                    !isEditAffiliateIdAvailable
                                "
                                class="vi-error"
                                style="top: -1em"
                                >{{
                                  errors.first("schOverview.afname")
                                    ? "Affiliate Id is required"
                                    : "Affiliate Id already registered. please use a different one."
                                }}</label
                              >

                              <label for="afid" v-else
                                >Affiliate ID
                                <span class="required">*</span></label
                              >
                            </span>
                          </div>
                          <div
                            class="form-group input-group col-md-6 pr-md-3 mt-3"
                          >
                            <span class="has-float-label">
                              <select
                                class="form-control form-input"
                                id="schtypeid"
                                name="schtypeid"
                                :disabled="isEdit"
                                v-validate="'required'"
                                v-model="schoolDetails.schoolType"
                                placeholder="School Type"
                              >
                                <option :value="null">-- Select --</option>
                                <option
                                  v-for="(item, index) in schoolTypeList"
                                  :key="index"
                                  :value="item"
                                >
                                  {{ item }}
                                </option>
                              </select>
                              <label
                                v-if="errors.first('schOverview.schtypeid')"
                                class="vi-error"
                                style="top:-1em"
                                >School Type is required</label
                              >
                              <label for="schtypeid" v-else
                                >School Type
                                <span class="required">*</span></label
                              >
                            </span>
                          </div>
                          <div
                            class="form-group input-group col-md-6 pr-md-3 mt-3"
                          >
                            <span class="has-float-label">
                              <v-select
                                class="form-control form-input"
                                label="label"
                                multiple
                                name="AffiliatedtoBoard"
                                v-validate="'required'"
                                :disabled="isEdit"
                                v-model="schoolDetails.affilliateIdToBoard"
                                :options="boardTypeList"
                                :reduce="(label) => label.value"
                              ></v-select>

                              <label
                                for="gardeTo"
                                class="vi-error"
                                style="top:-1em"
                                v-if="
                                  errors.first('schOverview.AffiliatedtoBoard')
                                "
                                >Affiliated to/Board is required
                                <span class="required">*</span></label
                              >
                              <label for="gardeTo" v-else
                                >Affiliated to/Board
                                <span class="required">*</span></label
                              >
                            </span>
                          </div>
                          <div
                            class="form-group input-group col-md-6 pr-md-3 mt-3"
                          >
                            <span class="has-float-label">
                              <select
                                :disabled="isEdit"
                                @change="
                                  setToClassAndSection(schoolDetails.gradeFrom)
                                "
                                v-model="schoolDetails.gradeFrom"
                                class="form-control form-input"
                                id="acyearid"
                                v-validate="'required'"
                                name="gradefrom"
                              >
                                <option :value="null">-- Select --</option>
                                <option
                                  v-for="(item, index) in fromClassList"
                                  :key="index"
                                  :value="item"
                                >
                                  {{ item }}
                                </option>
                              </select>
                              <label
                                v-if="errors.first('schOverview.gradefrom')"
                                class="vi-error"
                                style="top:-1em"
                                >Grade From is required</label
                              >
                              <label for="schtypeid" v-else>Grade From </label>
                            </span>
                          </div>
                          <div
                            class="form-group input-group col-md-6 pr-md-3 mt-3"
                          >
                            <span class="has-float-label">
                              <select
                               :disabled="isEdit"
                                v-model="schoolDetails.gradeTo"
                                class="form-control form-input"
                                id="gardeTo"
                                v-validate="'required'"
                                name="gardeTo"
                              >
                                <option :value="null">-- Select --</option>
                                <option
                                  v-for="(item, index) in toClassList"
                                  :key="index"
                                  :value="item"
                                >
                                  {{ item }}
                                </option>
                              </select>

                              <label
                                v-if="errors.first('schOverview.gardeTo')"
                                class="vi-error"
                                style="top:-1em"
                                >Grade To is required</label
                              >
                              <label for="gardeTo" v-else
                                >Grade To <span class="required">*</span></label
                              >
                            </span>
                          </div>

                         
                          <div
                            class="form-group input-group col-md-6 mt-3"
                            style="border-bottom: 1px solid #e5e5e5"
                          >
                            <span style="color: #6c757d" class="mr-3">
                              School Affiliation status is Active ?
                              <span class="required">*</span></span
                            >
                            <label class="switch">
                              <input
                                v-model="
                                  schoolDetails.statusOfSchoolAffiliation
                                "
                                type="checkbox"
                                id="togBtn"
                                :disabled="isEdit"
                              />
                              <div class="slider"></div>
                            </label>
                          </div>
                          <div
                            class="form-group input-group col-md-6 pr-md-3 mt-3"
                          >
                            <span class="has-float-label">
                              <input
                                type="date"
                                max="9999-12-31"
                                v-validate="'required'"
                                name="ysddde"
                                v-model="
                                  schoolDetails.YearOfSchoolEstablishment
                                "
                                class="form-control form-input"
                                :disabled="isEdit"
                              />
                              <label
                                for="landlineid"
                                class="vi-error"
                                style="top:-1em"
                                v-if="errors.first('schOverview.ysddde')"
                                >Year of School Establishment is required.
                              </label>
                              <label for="landlineid" v-else
                                >Year of School Establishment.
                                <span class="required">*</span></label
                              >
                            </span>
                          </div>

                          <div
                            class="form-group input-group col-md-6 pr-md-3 mt-3"
                          >
                            <span class="has-float-label">
                              <input
                                v-model="schoolDetails.schoolAffiliationGranted"
                                type="date"
                                max="9999-12-31"
                                v-validate="'required'"
                                name="SchoolAffiliationGranted"
                                class="form-control form-input"
                                id="landlineid"
                                :disabled="isEdit"
                              />
                              <label
                                for="landlineid"
                                class="vi-error"
                                style="top:-1em"
                                v-if="
                                  errors.first(
                                    'schOverview.SchoolAffiliationGranted'
                                  )
                                "
                                >School Affiliation Granted on is required.
                                <span class="required">*</span></label
                              >
                              <label for="landlineid" v-else
                                >School Affiliation Granted on
                                <span class="required">*</span></label
                              >
                            </span>
                          </div>

                          <div
                            class="form-group input-group col-md-6 pr-md-3 mt-3"
                          >
                            <span class="has-float-label">
                              <input
                                type="text"
                                name="landline"
                                v-model="schoolDetails.registeredName"
                                class="form-control form-input"
                                id="landlineid"
                                :disabled="isEdit"
                              />
                              <label for="landlineid"
                                >Name of the Trust/Society/institution/company
                                the school Registered with
                              </label>
                            </span>
                          </div>
                          <div
                            class="form-group input-group col-md-6 pr-md-3 mt-3"
                          >
                            <span class="has-float-label">
                              <input
                                type="number"
                                name="landline"
                                v-model="schoolDetails.minimumAge"
                                class="form-control form-input"
                                id="landlineid"
                                :disabled="isEdit"
                              />
                              <label for="landlineid"
                                >Minimum age of entry
                              </label>
                            </span>
                          </div>
                        
                          <div class="form-group input-group col-md-6 mt-3">
                            <span class="has-float-label">
                              <select
                                class="form-control form-input"
                                id="brdtypeid"
                                name="brdtypeid"
                                :disabled="isEdit"
                                v-validate="'required'"
                                v-model="schoolDetails.classification"
                              >
                                <option :value="null">-- Select --</option>
                                <option
                                  v-for="(item, index) in classificationList"
                                  :key="index"
                                  :value="item"
                                >
                                  {{ item }}
                                </option>
                              </select>

                              <label
                                v-if="errors.first('schOverview.brdtypeid')"
                                class="vi-error"
                                style="top:-1em"
                                >School Classification is required</label
                              >
                              <label for="brdtypeid" v-else
                                >School Classification
                                <span class="required">*</span></label
                              >
                            </span>
                          </div>
                          <div
                            class="form-group input-group col-md-6 pr-md-3 mt-3"
                          >
                            <span class="has-float-label">
                              <v-select
                                label="label"
                                multiple
                                :options="mediumList"
                                :reduce="(label) => label.value"
                                name="Medium"
                                v-validate="'required'"
                                v-model="schoolDetails.medium"
                                class="form-control form-input vselectFrmCtrl"
                                id="mediumid"
                                :disabled="isEdit"
                              ></v-select>

                             
                              <label
                                v-if="errors.first('schOverview.Medium')"
                                class="vi-error"
                                style="top:-1em"
                                >Language of instruction is required</label
                              >
                              <label for="mediumid" v-else
                                >Language of instruction
                                <span class="required">*</span></label
                              >
                            </span>
                          </div>
                          
                          <div
                            class="form-group input-group col-md-6 pr-md-3 mt-3"
                          >
                            <span class="has-float-label">
                              <input
                                type="text"
                                name="landline"
                                class="form-control form-input"
                                id="landlineid"
                                :disabled="isEdit"
                                v-model="schoolDetails.landlineNo"
                                placeholder="Landline No."
                              />
                              <label for="landlineid"
                                >Landline No
                                </label
                              >
                            </span>
                          </div>
                          <div
                            class="form-group input-group col-md-6 pr-md-3 mt-3"
                          >
                            <span class="has-float-label">
                              <input
                                type="text"
                                name="website"
                                class="form-control form-input"
                                id="websiteid"
                                :disabled="isEdit"
                                v-validate="'url'"
                                v-model="schoolDetails.website"
                                placeholder="Enter your school website"
                              />
                              <label
                                v-if="errors.first('schOverview.website')"
                                class="vi-error"
                                style="top:-1em"
                                >Website url format is wrong ( eg:
                                https://dev.vidhyaan.com )</label
                              >
                              <label for="mediumid" v-else>Website </label>
                            </span>
                          </div>

                          <div class="form-group input-group col-md-6 mt-md-3">
                            <span class="has-float-label">
                              <textarea
                                class="form-control form-input"
                                style="min-height: 90px; resize: none"
                                id="abtschlid"
                                :disabled="isEdit"
                                v-model="schoolDetails.overView"
                                placeholder="Describe about your School"
                              ></textarea>
                              <label for="schadr"
                                >Describe about your School</label
                              >
                            </span>
                          </div>

                          <div
                            class="form-group input-group col-md-6 mt-3"
                            style="border-bottom: 1px solid #e5e5e5"
                          >
                              Types of Admission ?
                              <span class="required">*</span>

                               <div class="nottble" style="margin-top:8px;">
                                <div class=" chkbox" data-title="Select">
                                    <label class="custcheckbox">
                                      <input :disabled="isEdit" type="checkbox" v-model="schoolDetails.isOnlineAdmission" />
                                      <span class="checkmarkchk"></span>
                                      
                                    </label>
                                    <label style="margin-left:35px;padding-top: 1%;">Online</label>
                                  </div>
                                  
                                </div>
                                 <div class="nottble" style="margin-top:8px;">
                                <div class=" chkbox" data-title="Select">
                                    <label class="custcheckbox">
                                      <input :disabled="isEdit" type="checkbox" v-model="schoolDetails.isOfflineAdmission" />
                                      <span class="checkmarkchk"></span>
                                      
                                    </label>
                                    <label style="margin-left:35px;padding-top: 1%;">Offline</label>
                                  </div>
                                  
                                </div>
                            
                          </div>

                          <div class="form-group input-group col-md-12 mt-md-3">
                            
                            <span class="has-float-label">
                              <v-select
                                class="form-control form-input vselectFrmCtrl"
                                style="margin-top: 1%;"
                                label="label"
                                name="AssignClasses"
                                v-validate="'required'"
                                multiple
                                v-model="schoolDetails.facilities"
                                :disabled="isEdit"
                                :options="getformatClassList"
                                :reduce="(label) => label.value"
                              ></v-select>

                              <label
                                v-if="errors.first('schOverview.AssignClasses')"
                                class="vi-error"
                                style="top:-1em"
                                >School Facitilities is required</label
                              >
                              <label v-else
                                >Add your School Facilities :
                                <span class="required">*</span></label
                              >
                            </span>
                          </div>
                        </div>
                      </div>
                      <div>
                        <label
                          style="margin: 0"
                          for="accordiongroup-1"
                          class="blutitle accordion-label"
                        >
                          For Vidhyaan Use Only
                        </label>

                        <div class="form-row">
                          <div
                            class="form-group input-group col-md-4 pr-md-3 mt-3"
                          >
                            <span class="has-float-label">
                              <input
                                type="text"
                                name="promoted"
                                class="form-control form-input"
                                id="promotedid"
                                placeholder="Promoted"
                                 :disabled="isEdit"
                                v-model="schoolDetails.promoted"
                              />
                              <label for="promotedid"
                                >Promoted <span class="required">*</span></label
                              >
                            </span>
                          </div>
                          <div
                            class="form-group input-group col-md-4 mt-3"
                            style="border-bottom: 1px solid #e5e5e5"
                          >
                            <span style="color: #6c757d" class="mr-3"
                              >Is Verified?
                              <span class="required">*</span></span
                            >
                            <label class="switch">
                              <input type="checkbox" v-model="schoolDetails.isVerified"  :disabled="isEdit" id="togBtn" />
                              <div class="slider"></div>
                            </label>
                          </div>
                          <div
                            class="form-group input-group col-md-4 pr-md-3 mt-3"
                          >
                            <span class="has-float-label">
                              <input
                                type="text"
                                name="promoted"
                                class="form-control form-input"
                                id="promotedid"
                                placeholder="status"
                                 :disabled="isEdit"
                                v-model="schoolDetails.status"
                              />
                              <label for="promotedid"
                                >Status <span class="required">*</span></label
                              >
                            </span>
                          </div>
                        </div>
                      </div>
                      <div>
                        <label
                          style="margin: 0"
                          for="accordiongroup-1"
                          class="blutitle accordion-label"
                        >
                          Principal Information
                        </label>
                        <div
                          class="form-row"
                          v-if="schoolDetails.principalInformation"
                        >
                          <div class="form-group input-group col-md-4 mt-3">
                            <span class="has-float-label">
                              <input
                                type="text"
                                name="areaId"
                                :disabled="isEdit"
                                v-model="
                                  schoolDetails.principalInformation
                                    .PrincipalName
                                "
                                class="form-control form-input"
                                id="ctid"
                              />

                              <label for="ctid">Name </label>
                            </span>
                          </div>
                          <div class="form-group input-group col-md-4 mt-3">
                            <span class="has-float-label">
                              <input
                                type="text"
                                v-validate="'email'"
                                name="prinEMail"
                                :disabled="isEdit"
                                v-model="
                                  schoolDetails.principalInformation
                                    .PrincipalEmail
                                "
                                class="form-control form-input"
                                id="ctid"
                              />
                              <label
                                v-if="errors.first('schOverview.prinEMail')"
                                class="vi-error"
                                style="top:-1em"
                                >Enter valid email id</label
                              >

                              <label v-else for="ctid">Email </label>
                            </span>
                          </div>
                          <div class="form-group input-group col-md-4 mt-3">
                            <span class="has-float-label">
                              <input
                                onKeyPress="if(this.value.length==15) return false;"
                                type="number"
                                name="areaId"
                                :disabled="isEdit"
                                v-model="
                                  schoolDetails.principalInformation
                                    .PrincipalPhone
                                "
                                class="form-control form-input"
                                id="ctid"
                              />

                              <label for="ctid">Phone </label>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div>
                        <label
                          style="margin: 0"
                          for="accordiongroup-1"
                          class="blutitle accordion-label"
                        >
                          Social Media Links
                        </label>
                        <div class="form-row" v-if="schoolDetails.socialMedia">
                          <div class="form-group input-group col-md-6 mt-3">
                            <span class="has-float-label">
                              <input
                                type="text"
                                name="areaId"
                                :disabled="isEdit"
                                v-model="schoolDetails.socialMedia.Facebook"
                                class="form-control form-input"
                                id="ctid"
                              />

                              <label for="ctid">Facebook URL </label>
                            </span>
                          </div>
                          <div class="form-group input-group col-md-6 mt-3">
                            <span class="has-float-label">
                              <input
                                type="text"
                                name="areaId"
                                :disabled="isEdit"
                                v-model="schoolDetails.socialMedia.Twitter"
                                class="form-control form-input"
                                id="ctid"
                              />

                              <label for="ctid">Twitter URL </label>
                            </span>
                          </div>
                          <div class="form-group input-group col-md-6 mt-3">
                            <span class="has-float-label">
                              <input
                                type="text"
                                name="areaId"
                                :disabled="isEdit"
                                v-model="schoolDetails.socialMedia.Linkedin"
                                class="form-control form-input"
                                id="ctid"
                              />

                              <label for="ctid">Linkedin URL </label>
                            </span>
                          </div>
                          <div class="form-group input-group col-md-6 mt-3">
                            <span class="has-float-label">
                              <input
                                type="text"
                                name="areaId"
                                :disabled="isEdit"
                                v-model="schoolDetails.socialMedia.Youtube"
                                class="form-control form-input"
                                id="ctid"
                              />

                              <label for="ctid">Youtube URL </label>
                            </span>
                          </div>
                        </div>
                      </div>
                </form>
              </div>
              <div class="widjetfooter text-right">
                <div class="dk_iconsml">
                  <div v-if="!isEdit">
                    <button
                      type="button"
                      class="btn btnsml"
                      id="svbtn"
                      @click.prevent="updateDetails"
                    >
                        <span>Save</span>
                    </button>
                    <button
                      type="button"
                      class="btn btncl"
                      id="clbtn"
                      @click.prevent="closeModal"
                    >
                         <span>Cancel</span>
                    </button>
                  </div>

                  <div v-if="isEdit">
                    <!-- <button
                      type="button"
                      class="btn btnsml edbtn"
                      @click.prevent="verifySchool"
                    >
                      <i class="fas fa-edit"></i> <span>Verify</span>
                    </button> -->
                    <button
                      type="button"
                      class="btn btncl"
                      id="clbtn"
                      @click.prevent="enableEditView"
                    >
                         <span>Edit</span>
                    </button>
                    <button
                      type="button"
                      class="btn btncl"
                      id="clbtn"
                      @click.prevent="openRejectConfirmation"
                    >
                         <span>Reject</span>
                    </button>
                    <button
                      type="button"
                      class="btn btncl"
                      id="clbtn"
                      @click.prevent="closeModal"
                    >
                         <span>Cancel</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            :class="{ 'active show': isActive('plan') }"
            id="plan"
          >
            <div class="widjet" v-if="schoolDetails.planDetails">
              <div class="p-3 mt-3 widjetcontent">
                 <div class="row" v-if="schoolDetails.version != 'freeVersion'">
                      <div class="col-lg-12">
                        <div class="widjet">
                          
                          <div class="tbllist mt-1">
                            <div class="restable">
                              <div class="resrow resheader">
                                <div class="cell" style="width: 10%">S.No</div>
                                <div class="cell">Subscription No</div>
                                <div class="cell">Subscription Status</div>
                                <div class="cell">Plan Name</div>
                                <div class="cell">Plan Activation Date</div>
                                <div class="cell">Plan Type</div>
                                <div class="cell">Next Billing Date</div>
                                <div class="cell">Amount</div>

                              </div>

                              <div
                                class="resrow"
                                v-for="(data, index) in subscriptions"
                                :key="index"
                              >
                               
                                <div class="cell" data-title="From Month">
                                  {{ index + 1 }}
                                </div>
                               
                                <div class="cell" data-title="From Year">
                                  <a href="javascript:void(0);" class="txtellipsis"  @click.prevent="viewSubscriptionDetails(index)">{{ data.subscription_number }}
                                 </a>
                                  
                                </div>
                                 <div class="cell" data-title="From Year" >
                                  {{ data.status }} 
                                </div>
                                 <!-- <div class="cell" data-title="From Year" v-else>
                                  {{ data.status }} (
                                  <a href="javascript:void(0);"  @click.prevent="paymentNow">Pay Now
                                 </a> )
                                </div> -->
                                
                                <div class="cell" data-title="From Month">
                                  {{ data.plan_name }}
                                </div>
                                <div class="cell" data-title="From Month">
                                  {{ data.activated_at }}
                                </div>
                                <div class="cell" data-title="From Year">
                                  {{ data.interval_unit }}
                                </div>
                                <div class="cell" data-title="From Year">
                                  {{ data.next_billing_at }}
                                </div>
                                <div class="cell" data-title="From Year">
                                  {{ data.amount }}
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                 
                </div>
                <div
                              class="form-row"
                              v-else
                            >
                              <div class="col-lg-12">
                                <div class="admintbl mt-1 p-3">
                                  <table border="1">
                                    <thead>
                                      <tr>
                                        <th scope="col" rowspan="2">
                                          Plan Name<span class="required"
                                            >*</span
                                          >
                                        </th>
                                        <th scope="col" rowspan="2">
                                          Plan Frequency<span class="required"
                                            >*</span
                                          >
                                        </th>
                                        <th scope="col" rowspan="2">
                                          Plan Start Date<span class="required"
                                            >*</span
                                          >
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td data-label="Fee Name">
                                          <input
                                            type="text"
                                            name="Plan Name"
                                            disabled
                                            value="SCHOOL ONLINE - Enroll - YEARLY"
                                            class="form-control form-input"
                                            id="Plan Name"
                                            placeholder="Plan Name"
                                          />
                                        </td>
                                        <td data-label="prefix">
                                          <input
                                            type="text"
                                            name="Plan Frequency"
                                            disabled
                                            value="Yearly"
                                            class="form-control form-input"
                                            id="Plan Frequency"
                                            placeholder="Plan Frequency"
                                          />
                                        </td>
                                        <td data-label="prefix">
                                          {{ schoolDetails.createdDate | dateFormat }}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                <!-- freeVersion -->
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            :class="{ 'active show': isActive('rating') }"
            id="rating"
          >
            <!-- <div class="widjet" v-if="schoolDetails.planDetails"> -->
              <div class="p-3 widjetcontent">
                 <div class="row">
                      <div class="col-lg-12">
                        <div class="widjet">
                          
                          <div class="tbllist mt-1">
                            <div class="restable">
                              <div class="resrow resheader">
                                <div class="cell">Parent Name</div>
                                <div class="cell">Review Submitted Date</div>
                                <div class="cell">Status</div>
                                <div class="cell">Overall Rating</div>
                                <div class="cell">Action</div>
                                

                              </div>

                              <div
                                class="resrow"
                                v-for="(data, index) in parentReviewList"
                                :key="index"
                              >
                                <div class="cell" data-title="From Year" >
                                  {{ data.parent ? data.parent.firstName : '' }} 
                                </div>
                                
                                
                                <div class="cell" data-title="From Month">
                                  {{ data.updatedDate | dateFormat }}
                                </div>
                                <div class="cell" data-title="From Month">
                                  {{ data.status }}
                                </div>
                                <div class="cell" data-title="From Year">
                                  <star-rating
                                    :star-size="20"
                                    :show-rating="false"
                                    inactive-color="#666"
                                    active-color="#ffa500"
                                    :rating="data.overAllRating"
                                    :increment="0.5"
                                    :read-only="true"
                                    class="vi-r-review"
                                  />
                                 
                                </div>
                                <div class="cell" data-title="From Year">
                                  <button class="btn round orange tooltipt" @click="openReviewParentModel(index)" >
                                   <i class="far fa-eye"></i><span class="tooltiptext">View</span>
                                  </button>
                                </div>
                               
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                 
                </div>
              <!-- </div> -->
            </div>
          </div>
          <div
            class="tab-pane fade"
            :class="{ 'active show': isActive('admission') }"
            id="admission"
          >
            <div>
              <div class="p-3">
                <table v-if="feesDetails">
                  <thead>
                    <tr>
                      <th scope="col" style="text-align: center;">Class Details</th>
                      <th scope="col" style="text-align: center;">No. of Seats</th>
                      <th scope="col" style="text-align: center;">Starting Fee</th>
                      <!-- <th scope="col">Online</th> -->
                    </tr>
                  </thead>
                  <tbody v-if="feesDetails.length > 0">
                    <tr v-for="(fee, index) in feesDetails" :key="index">
                      <td data-label="Class Details" style="text-align: center;">{{ fee.class ? fee.class.className : '' }}</td>
                      <td data-label="No. of Seats" style="text-align: center;">{{ fee.noOfSeats }}</td>
                      <td data-label="Total Fees" style="text-align: center;">
                        {{ fee.amount }}
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr style="text-align: center;">
                     
                     <td>
                     </td>
                      <td style="text-align: center;">NA
                     </td>
                      <td>
                     </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal id="modalTwo" class="modal">
      <button style="border:0;background:transparent;position:absolute;top:10px;right:10px;"
                    type="submit"
                    @click.prevent="backToHome"
                  >
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </button>
      <div class="col-md-12">
        <div class="card web-login-card p-4 mt-2 mb-5">
          <div style="margin-bottom:0;line-height:18px;">
            You are registering as a
            <h1>School/Institution</h1>
          </div>
          <form
              data-vv-scope="schoolRegister"
              id="schoolRegisterid"
              accept-charset="utf-8"
            >
              <div class="form-row">
                <div class="form-group input-group col-md-6 mt-md-3">
                  <span class="web-has-float-label">
                    <input
                      class="form-control web-form-input"
                      id="schnameid"
                      v-validate="'required'"
                      name="schoolName"
                      placeholder="School name"
                      v-model="schoolName"
                      maxlength="100"
                    />
                    <label
                      v-if="
                        errors.first('schoolRegister.schoolName') && showError
                      "
                      class="vi-error"
                      style="top: -1em"
                      >School Name is required</label
                    >

                    <label for="schnameid" v-else
                      >School Name<span class="required">*</span></label
                    >
                  </span>
                </div>

                <div class="form-group input-group col-md-6 mt-md-3">
                  <span class="web-has-float-label">
                    <input
                      @input="checkAffilliateId"
                      type="text"
                      name="affid"
                      v-validate="'required'"
                      v-model="affiliateID"
                      class="form-control web-form-input"
                      id="affid"
                      placeholder="Affiliate ID"
                      maxlength="50"
                    />

                    <label
                      v-if="
                        (errors.first('schoolRegister.affid') && showError) ||
                          !isAffiliateIdAvailable
                      "
                      class="vi-error"
                      style="top: -1em"
                      >{{
                        errors.first("schoolRegister.affid")
                          ? "Affiliate Id is required"
                          : "Affiliate Id already registered. please use a different one."
                      }}</label
                    >

                    <label for="affid" v-else
                      >Affiliate ID <span class="required">*</span></label
                    >
                  </span>
                </div>
                <div class="form-group input-group col-md-6">
                  <span class="web-has-float-label">
                    <input
                      type="text"
                      name="fname"
                      v-validate="'required'"
                      class="form-control web-form-input"
                      id="fnameid"
                      placeholder="First Name"
                      v-model="firstName"
                      maxlength="50"
                    />

                    <label
                      v-if="errors.first('schoolRegister.fname') && showError"
                      class="vi-error"
                      style="top: -1em"
                      >First Name is required</label
                    >

                    <label for="fnameid" v-else
                      >First Name <span class="required">*</span></label
                    >
                  </span>
                </div>
                <div class="form-group input-group col-md-6">
                  <span class="web-has-float-label">
                    <input
                      type="text"
                      name="lname"
                      v-validate="'required'"
                      class="form-control web-form-input"
                      id="lnameid"
                      placeholder="Last Name"
                      v-model="lastName"
                      maxlength="50"
                    />

                    <label
                      v-if="errors.first('schoolRegister.lname') && showError"
                      class="vi-error"
                      style="top: -1em"
                      >Last Name is required</label
                    >

                    <label for="lnameid" v-else
                      >Last Name <span class="required">*</span></label
                    >
                  </span>
                </div>
                <div class="form-group input-group col-md-6">
                  <span class="web-has-float-label">
                    <input
                      @focusout="checkEmail"
                      type="email"
                      name="email"
                      v-validate="'required'"
                      class="form-control web-form-input"
                      id="emailid"
                      placeholder="Email Id"
                      v-model="emailID"
                      maxlength="50"
                    />

                    <label
                      v-if="
                        (errors.first('schoolRegister.email') && showError) ||
                          !isEmailIdAvailable
                      "
                      class="vi-error"
                      style="top: -1em"
                      >{{
                        errors.first("schoolRegister.email")
                          ? "Email Id is required "
                          : "Email already exists in this or another Vidhyaan School Account. It must be unique across all Accounts."
                      }}
                    </label>
                    

                    <label for="emailid" v-else
                      >Email Id <span class="required">*</span></label
                    >
                  </span>
                </div>
                <div class="form-group input-group col-md-6 ">
                  <span class="web-has-float-label">
                    <input
                      type="text"
                      disabled
                      class="form-control form-input"
                      id="countryid"
                      placeholder="Country"
                      v-model="country"
                    />

                    <label for="countryid"
                      >Country<span class="required">*</span></label
                    >
                    <!-- <datalist id="countries">
                      <option value="India">India</option>
                    </datalist> -->
                  </span>
                </div>

                <div class="form-group input-group col-md-6">
                  <span class="web-has-float-label">
                    <vue-google-autocomplete
                    
                      ref="address"
                      id="map"
                      class="form-control form-input"
                      placeholder="Search Address"
                      country="IN"
                      types=""
                      v-on:placechanged="getAddressData"
                    >
                    </vue-google-autocomplete>
                    <label for="countryid"
                      >Address<span class="required">*</span></label
                    >
                    <!-- <datalist id="countries">
                      <option value="India">India</option>
                    </datalist> -->
                  </span>
                </div>
                <div class="form-group input-group col-md-6">
                  <span class="web-has-float-label">
                    <input
                      type="text"
                      v-model="state"
                      class="form-control form-input"
                      id="stateid"
                      v-validate="'required|alpha_spaces|max:100'"
                      name="stateValidate"
                      placeholder="State"
                    />

                    <label
                      v-if="
                        errors.first('schoolRegister.stateValidate') &&
                          showError
                      "
                      class="vi-error"
                      style="top: -1em"
                      >State is required</label
                    >

                    <label for="stateid" v-else
                      >State<span class="required">*</span></label
                    >
                  </span>
                </div>
                <div class="form-group input-group col-md-6">
                  <span class="web-has-float-label">
                    <input
                      type="text"
                      v-model="district"
                      class="form-control form-input"
                      id="stateid"
                      v-validate="'required|alpha_spaces|max:100'"
                      name="districtValidate"
                      placeholder="State"
                    />

                    <label
                      v-if="
                        errors.first('schoolRegister.districtValidate') &&
                          showError
                      "
                      class="vi-error"
                      style="top: -1em"
                      >District is required</label
                    >

                    <label for="stateid" v-else
                      >District<span class="required">*</span></label
                    >
                  </span>
                </div>
                <div class="form-group input-group col-md-6">
                  <span class="web-has-float-label">
                    <input
                      type="text"
                      v-model="city"
                      class="form-control form-input"
                      id="cityid"
                      v-validate="'required|alpha_spaces|max:100'"
                      name="cityValidate"
                      placeholder="City"
                    />

                    <label
                      v-if="
                        errors.first('schoolRegister.cityValidate') && showError
                      "
                      class="vi-error"
                      style="top: -1em"
                      >City/Town is required</label
                    >

                    <label for="stateid" v-else
                      >City / Town<span class="required">*</span></label
                    >
                  </span>
                </div>

                <div class="form-group input-group col-md-6">
                  <span class="web-has-float-label">
                    <input
                      type="text"
                      v-validate="'required|numeric|max:6|min:6'"
                      v-model="pincode"
                      class="form-control form-input"
                      id="stateid"
                      name="pinCodeValidate"
                      placeholder="pinCode"
                    />

                    <label
                      v-if="
                        errors.first('schoolRegister.pinCodeValidate') &&
                          showError
                      "
                      class="vi-error"
                      style="top: -1em"
                      >Pin Code is required</label
                    >

                    <label for="stateid" v-else
                      >Pin Code<span class="required">*</span></label
                    >
                  </span>
                </div>

                <div class="form-group input-group col-md-6 pr-md-0">
                  <span class="web-has-float-label">
                    <input
                      v-validate="'required'"
                      type="text"
                      name="stname"
                      class="form-control web-form-input"
                      id="stnameid"
                      placeholder="Street Name"
                      v-model="streetName"
                      maxlength="50"
                    />

                    <label
                      v-if="errors.first('schoolRegister.stname') && showError"
                      class="vi-error"
                      style="top: -1em"
                      >Street Name is required</label
                    >
                    <label for="stnameid" v-else
                      >Street Name<span class="required">*</span></label
                    >
                  </span>
                </div>

                <div class="form-group input-group col-md-6">
                  <span class="web-has-float-label">
                    <input
                      type="number"
                      onKeyPress="if(this.value.length==10) return false;"
                      @input="checkMobile"
                      v-validate="'required|numeric|min:10|max:10'"
                      name="mobno"
                      class="form-control web-form-input"
                      id="mobnoid"
                      placeholder="Mobile"
                      v-model="mobileNo"
                    />

                    <label
                      v-if="
                        (errors.first('schoolRegister.mobno') && showError) ||
                          !isPhoneNumberAvailable
                      "
                      class="vi-error"
                      style="top: -1em"
                    >
                      {{
                        errors.first("schoolRegister.mobno")
                          ? "Please enter a valid mobile number(10 digits)"
                          : "Mobile Number already exists in this or another Vidhyaan School Account. It must be unique across all Accounts."
                      }}</label
                    >

                    <label for="mobnoid" v-else
                      >Mobile <span class="required">*</span></label
                    >
                  </span>
                </div>
                <!-- <div class="form-group input-group col-md-6">
                  <span class="web-has-float-label">
                    <input
                      name="password"
                      ref="password"
                      type="password"
                      class="form-control form-input"
                      placeholder="Password"
                      v-validate="'required'"
                      v-model="password"
                      maxlength="50"
                    />

                    <label
                      v-if="
                        errors.first('schoolRegister.password') && showError
                      "
                      class="vi-error"
                      style="top: -1em"
                      >Password is required</label
                    >

                    <label for="pwdid" v-else
                      >Password <span class="required">*</span></label
                    >
                  </span>
                </div>
                <div class="form-group input-group col-md-6">
                  <span class="web-has-float-label">
                    <input
                      type="password"
                      name="Confirm Password"
                      placeholder="Password"
                      data-vv-as="password"
                      class="form-control form-input"
                      v-validate="'required|confirmed:password'"
                      v-model="confirmPassword"
                      id="confpwdid"
                      maxlength="50"
                    />

                    <label
                      v-if="
                        errors.first('schoolRegister.Confirm Password') &&
                          showError
                      "
                      class="vi-error"
                      style="top: -1em"
                      >Confirm Password mismatch and is required</label
                    >

                    <label for="confpwdid" v-else
                      >Confirm Password <span class="required">*</span></label
                    >
                  </span>
                </div> -->

                <div class="form-group input-group col-md-6"></div>

                <div class="form-group input-group col-md-12">
                  <div id="app" style="width: 100%;">
                    <GmapMap
                      :center="center"
                      :zoom="18"
                      map-style-id="roadmap"
                      :options="mapOptions"
                      style="width: 100%; height: 200px"
                      ref="mapRef"
                      @click="handleMapClick"
                    >
                      <GmapMarker
                        :position="marker.position"
                        :clickable="true"
                        :draggable="true"
                        @drag="handleMarkerDrag"
                        @click="panToMarker"
                      />
                    </GmapMap>
                    <!-- <button @click="geolocate">Detect Location</button> -->

                    <!-- <p>Selected Position: {{ marker.position }}</p> -->
                  </div>
                </div>

                <div
                  class="g-recaptcha"
                  id="recaptcha"
                  data-callback="checkResponse"
                  data-sitekey="6Lcs5UMeAAAAAApF9anTicewdEFZQbZesyw5C0VD"
                  style="width: 100%;"
                ></div>

                <div class="form-group col-md-12 web-btnalign pr-md-3">
                  <button
                    type="submit"
                    @click.prevent="submitForm"
                    class="web-custbutton mt-3 mr-2"
                  >
                    Register
                  </button>
                  <input
                    type="button"
                    class="web-cancelbutton mt-3"
                    value="Reset"
                    @click="clearForm"
                  />
                   <button
                    type="submit"
                    @click.prevent="backToHome"
                    class="web-custbutton mt-3 mr-2"
                  >
                    Back
                  </button>
                </div>
              </div>
            </form>
          <vi-spinner
            v-if="viLoader"
            text="Loading..."
            textColor="vi-brand-color"
            class="flex-fill h-100 vi-fs12"
            style="width: 100%;z-index: 111;top:0;left:0;background-color: rgba(255, 255, 255, 0.5);border-radius: 1rem;"
          />
        </div>
      </div>
    </b-modal>

    <b-modal id="modalThree" no-close-on-backdrop no-close-on-esc>
      <button type="button" class="close"  @click.prevent="closeRejectModal">×</button>

      <div class="contact-form">
        <h2>Reject Confirmation</h2>

        <div class="web-colwidth" style="width: 100% !important; border: 0">
          <div class="form-row">
            <div class="form-group input-group mt-md-3">
              <span class="web-has-float-label">
                <textarea
                  class="form-control web-form-input"
                  style="min-height: 135px; resize: none"
                  id="message"
                  placeholder="Please specify a reason to reject this school"
                  v-model="reason"
                ></textarea>
                <label for="message"
                  >Reason<span class="required">*</span></label
                >
              </span>
            </div>
          </div>
        </div>
        <div
          class="pt-3 text-right dk_iconsml"
          style="border-top: 1px solid #e5e5e5"
        >
          <button
            :disabled="!reason"
            @click.prevent="sendRejectionMail"
            type="button"
            class="btn btnsml"
            id="svbtn"
          >
              <span>Confirm</span>
          </button>
          <button
            @click.prevent="closeRejectModal"
            type="button"
            class="btn btncl clsmdl"
            id="clbtn"
          >
               <span>Cancel</span>
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal id="reviewModel" no-close-on-backdrop no-close-on-esc>
      <button type="button" class="close"  @click.prevent="closeReviewModal">×</button>

      <div class="contact-form">
       <div class="p-3">
              <div>
                <p><strong>Ratings & Reviews </strong></p>
                <hr />
                <div class="web-dispflex">
                  <div>
                    <p>
                      <label> School Infrastructure: </label>
                      <star-rating
                        :star-size="20"
                        :show-rating="false"
                        inactive-color="#666"
                        active-color="#ffa500"
                        :read-only="recordId ? true : false"
                        v-model="schoolData.infrastructure"
                        :increment="1"
                        
                        class="vi-r-review"
                      />
                    </p>
                    <p>
                      <label>School Management: </label>
                      <star-rating
                        :star-size="20"
                        :show-rating="false"
                        inactive-color="#666"
                        active-color="#ffa500"
                        :increment="1"
                        :read-only="recordId ? true : false"
                        v-model="schoolData.management"
                        class="vi-r-review"
                      />
                    </p>
                     <p>
                      <label>Lab Facilities: </label>
                      <star-rating
                        :star-size="20"
                        :show-rating="false"
                        inactive-color="#666"
                        active-color="#ffa500"
                        :increment="1"
                        :read-only="recordId ? true : false"
                        v-model="schoolData.facilities"
                        class="vi-r-review"
                      />
                    </p>
                    <p>
                      <label>Extra Curricular: </label>
                      <star-rating
                        :star-size="20"
                        v-model="schoolData.sports"
                        :show-rating="false"
                        inactive-color="#666"
                        :read-only="recordId ? true : false"
                        active-color="#ffa500"
                        :increment="1"
                        class="vi-r-review"
                      />
                    </p>
                    <p>
                      <label>Faculty: </label>
                      <star-rating
                        :star-size="20"
                        :show-rating="false"
                        inactive-color="#666"
                        active-color="#ffa500"
                        :increment="1"
                       :read-only="recordId ? true : false"
                        v-model="schoolData.faculty"
                        class="vi-r-review"
                      />
                    </p>
                    <p>
                      <label>Safety: </label>
                      <star-rating
                        :star-size="20"
                        v-model="schoolData.safety"
                        :show-rating="false"
                        inactive-color="#666"
                        :read-only="recordId ? true : false"
                        active-color="#ffa500"
                        :increment="1"
                        class="vi-r-review"
                      />
                    </p>
                  </div>
                  <div class="web-overall">
                    <p>{{ schoolData | averageRating }}</p>
                    <p>
                      <star-rating
                        :star-size="20"
                        :show-rating="false"
                        inactive-color="#666"
                        active-color="#ffa500"
                        :rating="schoolData | averageRating"
                        :increment="0.5"
                        :read-only="true"
                        class="vi-r-review"
                      />
                    </p>
                    <p>(Over All) {{ schoolData | averageRating }} ratings </p>
                  </div>
                </div>
              </div>
            </div>
        <div class="web-colwidth" style="width: 100% !important; border: 0">
          <div class="form-row">
            <div class="form-group input-group mt-md-3">
              <span class="web-has-float-label">
                <textarea
                  class="form-control web-form-input"
                  style="min-height: 135px; resize: none"
                  id="message"
                  :disabled="recordId"
                  placeholder="Enter your comments.."
                  v-model="adminComments"
                ></textarea>
                <label for="message"
                  >Comments<span class="required">*</span></label
                >
              </span>
            </div>
          </div>
        </div>
        <div
          class="pt-3 text-right dk_iconsml"
          style="border-top: 1px solid #e5e5e5"
        >
          <button v-if="!recordId"
            type="button"
            class="btn btnsml"
            @click="saveAdminReview"
            id="svbtn"
          >
              <span>Submit</span>
          </button>
          <button
            @click.prevent="closeReviewModal"
            type="button"
            class="btn btncl clsmdl"
            id="clbtn"
          >
               <span>Cancel</span>
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal id="reviewParentModel" no-close-on-backdrop no-close-on-esc>
      <button type="button" class="close"  @click.prevent="closeReviewParentModal">×</button>

      <div class="contact-form">
       <div class="p-3">
              <div>
                <p><strong>Ratings & Reviews </strong></p>
                <hr />
                <div class="web-dispflex">
                  <div>
                    <p>
                      <label> School Infrastructure: </label>
                      <star-rating
                        :star-size="20"
                        :show-rating="false"
                        inactive-color="#666"
                        active-color="#ffa500"
                        :read-only="true"
                        v-model="parentReview.infrastructure"
                        :increment="1"
                        
                        class="vi-r-review"
                      />
                    </p>
                    <p>
                      <label>School Management: </label>
                      <star-rating
                        :star-size="20"
                        :show-rating="false"
                        inactive-color="#666"
                        active-color="#ffa500"
                        :increment="1"
                        :read-only="true"
                        v-model="parentReview.management"
                        class="vi-r-review"
                      />
                    </p>
                     <p>
                      <label>Lab Facilities: </label>
                      <star-rating
                        :star-size="20"
                        :show-rating="false"
                        inactive-color="#666"
                        active-color="#ffa500"
                        :increment="1"
                        :read-only="true"
                        v-model="parentReview.facilities"
                        class="vi-r-review"
                      />
                    </p>
                    <p>
                      <label>Extra Curricular: </label>
                      <star-rating
                        :star-size="20"
                        v-model="parentReview.sports"
                        :show-rating="false"
                        inactive-color="#666"
                        active-color="#ffa500"
                        :increment="1"
                        :read-only="true"
                        class="vi-r-review"
                      />
                    </p>
                    <p>
                      <label>Faculty: </label>
                      <star-rating
                        :star-size="20"
                        :show-rating="false"
                        inactive-color="#666"
                        active-color="#ffa500"
                        :increment="1"
                        :read-only="true"
                        v-model="parentReview.faculty"
                        class="vi-r-review"
                      />
                    </p>
                    <p>
                      <label>Safety: </label>
                      <star-rating
                        :star-size="20"
                        v-model="parentReview.safety"
                        :show-rating="false"
                        inactive-color="#666"
                        active-color="#ffa500"
                        :increment="1"
                        :read-only="true"
                        class="vi-r-review"
                      />
                    </p>
                  </div>
                  <div class="web-overall">
                    <p>{{ parentReview | averageRating }}</p>
                    <p>
                      <star-rating
                        :star-size="20"
                        :show-rating="false"
                        inactive-color="#666"
                        active-color="#ffa500"
                        :rating="parentReview | averageRating"
                        :increment="0.5"
                        :read-only="true"
                        class="vi-r-review"
                      />
                    </p>
                    <p>(Over All)</p>
                  </div>
                </div>
              </div>
              <div class="web-colwidth" style="width: 100% !important; border: 0">
          <div class="form-row">
            <div class="form-group input-group mt-md-3">
              <span class="web-has-float-label">
                <textarea
                  class="form-control web-form-input"
                  style="min-height: 135px; resize: none"
                  id="message"
                  disabled
                  placeholder="Enter your comments.."
                  v-model="parentReviewDetails.comment"
                ></textarea>
                <label for="message"
                  >Comments<span class="required">*</span></label
                >
              </span>
            </div>
          </div>
        </div>
              <div>
                <p><strong>For Vidhyaan Use Only  </strong></p>
                <hr />
                <div class="web-dispflex">
                  <div>
                    <p>
                      <label> Status: </label>
                       <select
                          class="form-control form-input"
                          id="deptlistid" v-model="parentReviewDetails.status"
                        >
                          <option :value="null">--Select--</option>
                          <option
                            v-for="(item, index) in ratingStatusList"
                            :key="index"
                            :value="item"
                          >
                            {{ item }} 
                          </option>
                        </select>
                    </p>
                    
                  </div>
                  
                </div>
              </div>
            </div>
        <div class="web-colwidth" style="width: 100% !important; border: 0">
          <div class="form-row">
            <div class="form-group input-group mt-md-3">
              <span class="web-has-float-label">
                <textarea
                  class="form-control web-form-input"
                  style="min-height: 135px; resize: none"
                  id="message"
                  placeholder="Enter your comments.."
                  v-model="parentReviewDetails.vidhyaanComment"
                ></textarea>
                <label for="message"
                  >Admin Comments<span class="required">*</span></label
                >
              </span>
            </div>
          </div>
        </div>
        <div
          class="pt-3 text-right dk_iconsml"
          style="border-top: 1px solid #e5e5e5"
        >
          <button
            type="button"
            class="btn btnsml"
            id="svbtn"
            @click="updateRating"
          >
              <span>Update</span>
          </button>
          <button
            @click.prevent="closeReviewParentModal"
            type="button"
            class="btn btncl clsmdl"
            id="clbtn"
          >
               <span>Cancel</span>
          </button>
        </div>
      </div>
    </b-modal>
    
    <b-modal id="actionApprovePopup" no-close-on-backdrop
      no-close-on-esc >
      <button type="button" class="close"  @click.prevent="closeActionPopUp">×</button>

      <!-- <div class="modal-content"> -->
      <div class="contact-form">
        <!-- <span class="close">&times;</span> -->
        <h2>Approve Confirmation</h2>
        <br />
        Are you sure you want to Approve this school?
        <div
          class="pt-3 text-right dk_iconsml"
          style="border-top: 1px solid #e5e5e5"
        >
          <button
           @click.prevent="actionConfirm"
            type="button"
            class="btn btnsml"
            id="svbtn"
          >
              <span>Confirm</span>
          </button>
          <button @click.prevent="closeActionPopUp" type="button" class="btn btncl clsmdl" id="clbtn">
               <span>Cancel</span>
          </button>
        </div>
      </div>
      <!-- </div> -->
     </b-modal>
     
    <b-modal id="showSubscriptionPopUp" no-close-on-backdrop no-close-on-esc>
        <div class="contact-form">
          <h2> Subscription Details</h2>
          <br />
          <div>
            <form
              data-vv-scope="teacherValidate"
              id="addteacher"
              accept-charset="utf-8"
            >
              <div class="form-row">
                <div class="form-group input-group col-md-6 mt-3 pr-md-3">
                  <span class="has-float-label">
                    <input
                      type="text"
                      name="teacherName"
                      class="form-control form-input"
                      id="tchrnameid"
                      disabled
                      v-model="planDetails.customer_id"
                    />
                   
                  <label for="tchrnameid" 
                    >Customer Id </label
                  >

                  </span>
                </div>
                <div class="form-group input-group col-md-6 mt-3 pr-md-3">
                  <span class="has-float-label">
                    <input
                      type="text"
                      name="teacherName"
                      class="form-control form-input"
                      id="tchrnameid"
                      disabled
                      v-model="planDetails.plan_name"
                    />
                   
                  <label for="tchrnameid" 
                    >Plan Name </label
                  >

                  </span>
                </div>
                <div class="form-group input-group col-md-6 mt-3 pr-md-3">
                  <span class="has-float-label">
                    <input
                      type="text"
                      name="teacherName"
                      class="form-control form-input"
                      id="tchrnameid"
                      disabled
                      v-model="planDetails.subscription_id"
                    />
                   
                  <label for="tchrnameid" 
                    >Subscription Id </label
                  >

                  </span>
                </div>
                <div class="form-group input-group col-md-6 mt-3 pr-md-3">
                  <span class="has-float-label">
                    <input
                      type="text"
                      name="teacherName"
                      class="form-control form-input"
                      id="tchrnameid"
                      disabled
                      v-model="planDetails.status"
                    />
                   
                  <label for="tchrnameid" 
                    >Status </label
                  >

                  </span>
                </div>
                <div class="form-group input-group col-md-6 mt-3 pr-md-3" v-if="planDetails.status == 'live'">
                  <span class="has-float-label">
                    <input
                      type="text"
                      name="teacherName"
                      class="form-control form-input"
                      id="tchrnameid"
                      disabled
                      v-model="planDetails.activated_at"
                    />
                   
                  <label for="tchrnameid" 
                    >Plan Activation Date </label
                  >

                  </span>
                </div>
                 <div class="form-group input-group col-md-6 mt-3 pr-md-3" v-if="planDetails.status == 'cancelled'">
                  <span class="has-float-label">
                    <input
                      type="text"
                      name="teacherName"
                      class="form-control form-input"
                      id="tchrnameid"
                      disabled
                      v-model="planDetails.cancelled_at"
                    />
                   
                  <label for="tchrnameid" 
                    >Plan Cancelled Date </label
                  >

                  </span>
                </div>
                 <div class="form-group input-group col-md-6 mt-3 pr-md-3">
                  <span class="has-float-label">
                    <input
                      type="text"
                      name="teacherName"
                      class="form-control form-input"
                      id="tchrnameid"
                      disabled
                      v-model="planDetails.current_term_starts_at"
                    />
                   
                  <label for="tchrnameid" 
                    >Plan start date </label
                  >

                  </span>
                </div>
                <div class="form-group input-group col-md-6 mt-3 pr-md-3">
                  <span class="has-float-label">
                    <input
                      type="text"
                      name="teacherName"
                      class="form-control form-input"
                      id="tchrnameid"
                      disabled
                      v-model="planDetails.current_term_ends_at"
                    />
                   
                  <label for="tchrnameid" 
                    >Plan end date </label
                  >

                  </span>
                </div>
                <div class="form-group input-group col-md-6 mt-3 pr-md-3">
                  <span class="has-float-label">
                    <input
                      type="text"
                      name="teacherName"
                      class="form-control form-input"
                      id="tchrnameid"
                      disabled
                      v-model="planDetails.shipping_interval_unit"
                    />
                   
                  <label for="tchrnameid" 
                    >Interval unit </label
                  >

                  </span>
                </div>
                <!-- <div class="form-group input-group col-md-6 mt-3 pr-md-3" v-if="planDetails.status == 'live'">
                  <span class="has-float-label">
                    <input
                      type="text"
                      name="teacherName"
                      class="form-control form-input"
                      id="tchrnameid"
                      disabled
                      :value="currentPlanDetails"
                    />

                  <label for="tchrnameid" 
                    >Total no of students </label
                  >

                  </span>
                </div>
                 <div class="form-group input-group col-md-6 mt-3 pr-md-3" v-if="planDetails.status == 'live'">
                  <span class="has-float-label">
                    <input
                      type="text"
                      name="teacherName"
                      class="form-control form-input"
                      id="tchrnameid"
                      disabled
                      v-model="createdStudent"
                    />
                   
                  <label for="tchrnameid" 
                    >No of created students </label
                  >

                  </span>
                </div>
                 <div class="form-group input-group col-md-6 mt-3 pr-md-3" v-if="planDetails.status == 'live'">
                  <span class="has-float-label">
                    <input
                      type="text"
                      name="teacherName"
                      class="form-control form-input"
                      id="tchrnameid"
                      disabled
                      :value="remainingStudent(currentPlanDetails)"
                    />
                   
                  <label for="tchrnameid" 
                    >No of remaining student </label
                  >

                  </span>
                </div> -->
                
                
              </div>
              <div
                class="dispflex mt-3 pt-3"
                style="border-top: 1px solid #e5e5e5"
              >
                <div class="dk_icon">
                
                </div>
                <div class="text-right dk_iconsml">
                  <button type="button" @click.prevent="closePoup" class="btn btncl clsmdl" id="clbtn">
                       <span>Cancel</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
         
        </div>
    </b-modal>
    <b-modal id="viewPopUp" style="width: 100%">
      <button type="button" class="close"  @click.prevent="closeViewPopUp">×</button>

      <div class="contact-form">
        <h2>View</h2>
        <br />
        <div>
          <form data-vv-scope="departConfig" accept-charset="utf-8">
            <div class="form-row">
                <div class="form-group input-group col-md-4 pr-md-3 mt-3">
                <span class="has-float-label">
                  <input
                    disabled
                    v-model="editDetails.title"
                    name="title"
                    v-validate="'required'"
                    class="form-control form-input"
                    id="title"
                  />
                  <label
                    v-if="errors.first('departConfig.title')"
                    class="vi-error"
                    for="Start"
                    style="top: -1em"
                    >Title is required</label
                  >
                  <label v-else for="Start">Title </label>
                </span>
              </div>
                 <div class="form-group input-group col-md-4 pr-md-3 mt-3">
                <span class="has-float-label">
                    <select disabled
                          name="Format"
                          v-model="editDetails.stage"
                          class="form-control form-input"
                          id="Format"
                        >
                          <option value="">--Select--</option>
                          <option
                            v-for="(item, index) in priorityList"
                            :key="index"
                            :value="item"
                          >
                            {{ item }}  
                          </option>
                        </select>
                 
                  <label  for="Format">Priority</label>
                </span>
              </div>
              <div class="form-group input-group col-md-4 pr-md-3 mt-3">
                <span class="has-float-label">
                  <input disabled
                    v-model="editDetails.email"
                    name="Start"
                    v-validate="'required'"
                    class="form-control form-input"
                    id="Start"
                  />
                  <label
                    v-if="errors.first('departConfig.Start')"
                    class="vi-error"
                    for="Start"
                    style="top: -1em"
                    >Email is required</label
                  >
                  <label v-else for="Start">Email </label>
                </span>
              </div>
              <div class="form-group input-group col-md-12 pr-md-3 mt-3">
                <span class="has-float-label">
                     <textarea v-validate="'required'"
                        class="form-control web-form-input"
                        style="min-height:140px;resize:none"
                        id="Prefsssix"
                        disabled
                        v-model="editDetails.description"
                        placeholder="What would you like to be able to do? How would that help you..?"
                        ></textarea>
                  <!-- <input
                    type="text"
                    name="Prefix"
                    v-validate="'required'"
                    class="form-control form-input"
                    id="Prefix"
                    placeholder="What would you like to be able to do? How would that help you..?"
                  /> -->
                  <label
                    v-if="errors.first('departConfig.Prefsssix')"
                    class="vi-error"
                    for="Prefix"
                    style="top: -1em"
                    >Please write some ideas</label
                  >
                  <label v-else for="Prefix">Write your idea </label>
                </span>
              </div>
             
            </div>
          </form>

          <div class="mt-3 pt-3" style="border-top: 1px solid #e5e5e5">
            <!-- <div class="dk_icon"></div> -->
            <div class="text-center dk_iconsml">
              <!-- <button
                type="button"
                class="btn btnsml"
                id="svbtn"
                @click="saveIdea"
              >
                <i class="far fa-save"></i> <span>Submit</span>
              </button> -->

              <button
                type="button"
                class="btn btncl clsmdl"
                id="clbtn"
                @click.prevent="closeViewPopUp"
              >
                   <span>Close</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal id="viewGRandLoginPopUp" style="width: 100%">
      <button type="button" class="close"  @click.prevent="closeGrantpopup">×</button>

      <div class="contact-form">
        <h2>Grant Login View</h2>
        <br />
        <div>
          <div class="restable" styele="margin-left: 178px;">
                    <div class="resrow resheader">
                      <div class="cell">Branch Name</div>
                     
                      <div class="cell">Action</div>
                    </div>
                    <div class="resrow" v-for="(data, index) in branchList" :key="index">
                     
                      <div class="cell" data-title="Plan Name">{{ data.accountName }}</div>
                  
                      
                      <div class="cell" data-title="Action">
                        <button v-if="data.isGrandLoginActive"
                                  style="padding: 0.375rem 0.75rem; line-height: 1.5;"
                                  class="web-custbtn web-lgd web-rounded-xl h-100 btn-3"
                                  id="regbtnid"
                                 
                                  @click="redirectCustomRoute(data.accountId,data._id)"
                                >
                                  Login
                                </button>
                                <span v-else>No Access</span>
                       
                      </div>
                    
                    </div>
                   
                  </div>

         

          <!-- <div class="mt-3 pt-3" style="border-top: 1px solid #e5e5e5">
            <div class="text-center dk_iconsml">
            

              <button
                type="button"
                class="btn btncl clsmdl"
                id="clbtn"
                @click.prevent="closeViewPopUp"
              >
                   <span>Close</span>
              </button>
            </div>
          </div> -->
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import "vue-awesome/icons/restroom";
import "vue-awesome/icons/clinic-medical";
import "vue-awesome/icons/bed";
import "vue-awesome/icons/book";
import "vue-awesome/icons/laptop-code";
import "vue-awesome/icons/volleyball-ball";
import "vue-awesome/icons/utensils";
import "vue-awesome/icons/wheelchair";
import "vue-awesome/icons/bus-alt";
import "vue-awesome/icons/snowflake";
import "vue-awesome/icons/chalkboard-teacher";
import "vue-awesome/icons/concierge-bell";
import "vue-awesome/icons/shuttle-van";
import "vue-awesome/icons/bus";
import "vue-awesome/icons/satellite";
import "vue-awesome/icons/user-shield";
import "vue-awesome/icons/atom";
import "vue-awesome/icons/microscope";
import "vue-awesome/icons/server";
import "vue-awesome/icons/robot";
import "vue-awesome/icons/square-root-alt";
import "vue-awesome/icons/sort-alpha-down";
import "vue-awesome/icons/book-reader";
import "vue-awesome/icons/user-lock";
import "vue-awesome/icons/map-marker-alt";
import ViSpinner from "../Common/ViSpinner";
import ViService from "@/services/ViService";
import errorLog from "@/utils/errorLog";
import secureUI from "../../utils/secureUI";
import StarRating from "vue-star-rating";
import "vue-awesome/icons/arrow-left";
import "vue-select/dist/vue-select.css";
import Select from "vue-select";
import order from "../Common/order";
import convert from "../Common/csvconvert";
import VueGoogleAutocomplete from "vue-google-autocomplete";


export default {
  name: "vi-admin-panel",
  props: ["swapComponent"],
  components: {
    ViSpinner,
    StarRating,
    "v-select": Select,
    VueGoogleAutocomplete
  },

  data() {
    return {
      scList: null,
      parentReviewList: [],
      newFeatureList: [],
      underConsiderationFeatureList: [],
      plannedFeatureList : [],
      inProgressFeatureList: [],
      lanuchedFeatureList: [],
      schoolReviewId: null,
      recordId: null,
      editDetails: {
          _id: null,
          title: '',
          status: '',
          description: '',
          email: '',
          viewCount: 0,
          stage: ''
      },
      parentReview: {
            infrastructure: 0,
            sports: 0,
            facilities: 0,
            management: 0,
            faculty: 0,
            safety: 0
      },
      parentReviewDetails: {
          
      },

      ratingStatusList: [
        'Submitted',
        'Approved',
        'Needs Review',
        'Rejected'
      ],
      schoolData: {
            _id: null,
            infrastructure: 0,
            sports: 0,
            facilities: 0,
            management: 0,
            faculty: 0,
            safety: 0
      },
      adminComments: '',
      stateList: {
        AN: "Andaman and Nicobar Islands",
        AP: "Andhra Pradesh",
        AR: "Arunachal Pradesh",
        AS: "Assam",
        BR: "Bihar",
        CH: "Chandigarh",
        CT: "Chhattisgarh",
        DN: "Dadra and Nagar Haveli",
        DD: "Daman and Diu",
        DL: "Delhi",
        GA: "Goa",
        GJ: "Gujarat",
        HR: "Haryana",
        HP: "Himachal Pradesh",
        JK: "Jammu and Kashmir",
        JH: "Jharkhand",
        KA: "Karnataka",
        KL: "Kerala",
        LD: "Lakshadweep",
        MP: "Madhya Pradesh",
        MH: "Maharashtra",
        MN: "Manipur",
        ML: "Meghalaya",
        MZ: "Mizoram",
        NL: "Nagaland",
        OR: "Odisha",
        PY: "Puducherry",
        PB: "Punjab",
        RJ: "Rajasthan",
        SK: "Sikkim",
        TN: "Tamil Nadu",
        TG: "Telangana",
        TR: "Tripura",
        UP: "Uttar Pradesh",
        UT: "Uttarakhand",
        WB: "West Bengal",
      },
      priorityList: [
       'NICE-TO-HAVE',
       'IMPORTANT',
       'CRITICAL'
      ],
      statusList: [
        'New',
        'Under Consideration',
        'Planned',
        'In Progress',
        'Launched'
      ],
      schoolTypeList: [
        "Private",
        "Government",
        "Public Aided",
        "International",
        "National open school",
        "Special-needs",
        "Home school",
        "Distance education",
        "Montessori",
      ],
        fromClassList: [
        "Pre-Nursery",
        "Nursery",
        "LKG",
        "UKG",
        "KG",
        "Class 1",
        "Class 2",
        "Class 3",
        "Class 4",
        "Class 5",
        "Class 6",
        "Class 7",
        "Class 8",
        "Class 9",
        "Class 10",
        "Class 11",
        "Class 12",
      ],
      toClassList: [],
      boardTypeList: [
        {
          label: "State Board",
          value: "State Board",
        },
        {
          label: "STATE BOARD (till 10th)",
          value: "STATE BOARD (till 10th)",
        },
        {
          label: "STATE BOARD (till 12th)",
          value: "STATE BOARD (till 12th)",
        },
        {
          label: "CBSE",
          value: "CBSE",
        },
        {
          label: "ICSE",
          value: "ICSE",
        },
        {
          label: "ICSE & ISC",
          value: "ICSE & ISC",
        },
        {
          label: "IGCSE",
          value: "IGCSE",
        },
        {
          label: "IGCSE & CIE",
          value: "IGCSE & CIE",
        },
        {
          label: "CIE",
          value: "CIE",
        },
        {
          label: "1B",
          value: "1B",
        },
        {
          label: "IB PYP ONLY",
          value: "IB PYP ONLY",
        },
        {
          label: "IB PYP & MYP ONLY",
          value: "IB PYP & MYP ONLY",
        },
        {
          label: "IB PYP MYP & DYP",
          value: "IB PYP MYP & DYP",
        },
        {
          label: "IB DP",
          value: "IB DP",
        },
        {
          label: "To be affiliated to CBSE",
          value: "To be affiliated to CBSE",
        },
        {
          label: "To be affiliated to ISC/ICSE",
          value: "To be affiliated to ISC/ICSE",
        },
        {
          label: "To be affiliated to STATE/OTHER BOARD",
          value: "To be affiliated to STATE/OTHER BOARD",
        },
        {
          label: "To be affiliated to INTERNATIONAL BOARD",
          value: "To be affiliated to INTERNATIONAL BOARD",
        },
      ],
      classificationList: [
        "Co-Ed School",
        "Only Boys School",
        "Only Girls School",
      ],
      mediumList: [
        {
          label: "English",
          value: "English",
        },
        {
          label: "Tamil",
          value: "Tamil",
        },
        {
          label: "Telugu",
          value: "Telugu",
        },
        {
          label: "Urdu",
          value: "Urdu",
        },
        {
          label: "Sanskrit",
          value: "Sanskrit",
        },
        {
          label: "Kannada",
          value: "Kannada",
        },
        {
          label: "Malayalam",
          value: "Malayalam",
        },
        {
          label: "Odia",
          value: "Odia",
        },
        {
          label: "Punjabi",
          value: "Punjabi",
        },
        {
          label: "Hindi",
          value: "Hindi",
        },
        {
          label: "Bengali",
          value: "Bengali",
        },
        {
          label: "Gujarati",
          value: "Gujarati",
        },
        {
          label: "Assamese",
          value: "Assamese",
        },
      ],

      filtersList: ["School Name", "Type"],
      checkedBoardType: [],
      checkedschoolType: [],
      pincodeList: [],
      accountList: [],
      branchList: [],
      perPage: 15,
      currentPage: 1,
      selected: 1,
      schoolId: null,
      schoolEmail: "",
      reason: "",
      updateActionId : null,
      updateActionMail : '',
      schoolDetails: {},
      feesDetails: [],
      isEdit: false,
      Facilities: [],
       stateList: {
        AN: "Andaman and Nicobar Islands",
        AP: "Andhra Pradesh",
        AR: "Arunachal Pradesh",
        AS: "Assam",
        BR: "Bihar",
        CH: "Chandigarh",
        CT: "Chhattisgarh",
        DN: "Dadra and Nagar Haveli",
        DD: "Daman and Diu",
        DL: "Delhi",
        GA: "Goa",
        GJ: "Gujarat",
        HR: "Haryana",
        HP: "Himachal Pradesh",
        JK: "Jammu and Kashmir",
        JH: "Jharkhand",
        KA: "Karnataka",
        KL: "Kerala",
        LD: "Lakshadweep",
        MP: "Madhya Pradesh",
        MH: "Maharashtra",
        MN: "Manipur",
        ML: "Meghalaya",
        MZ: "Mizoram",
        NL: "Nagaland",
        OR: "Odisha",
        PY: "Puducherry",
        PB: "Punjab",
        RJ: "Rajasthan",
        SK: "Sikkim",
        TN: "Tamil Nadu",
        TG: "Telangana",
        TR: "Tripura",
        UP: "Uttar Pradesh",
        UT: "Uttarakhand",
        WB: "West Bengal",
      },
      districtList: [],
      allDistrictList: [],
      activeItem: "schoolInfo",
      schoolName: null,
      affiliateID: null,
      streetName: null,
      addressLine: null,
      state: null,
      district: null,
      country: "India",
      firstName: null,
      lastName: null,
      city: "",
      emailID: null,
      websiteURL: null,
      landlineNo: null,
      mobileNo: null,
      password: null,
      confirmPassword: null,
      viLoader: null,
      isEmailIdAvailable: true,
      isAffiliateIdAvailable: true,
      isEditAffiliateIdAvailable: true,
      searchWords: "",
      skip: 0, // set the skip info
      limit: 10, // set the limit info
      schoolView: true,
      termsAndConditionsView: false,
      featureRequestView: false,
      termsAndConditionsList: [],
      subscriptions: [],
      invoiceDetails: [],
      planDetails: {},
      totalStudent: 0,
      createdStudent: 0,
      reType: 'Auto-Renewal',
      currentPageNumber: 1,
      lastPageNumber: 1,
      countAll: true,
      isPhoneNumberAvailable: true,
      showError: true,
      pincode: "",
      address: "",
      marker: { position: { lat: 13.061931068989976, lng: 80.25831401348114 } },
      center: { lat: 13.061931068989976, lng: 80.25831401348114 },

      mapOptions: {
        disableDefaultUI: true,
      }
    };
  },

  created() {
    this.getAccountList();
    this.getTermsAndConditionsListList();
    this.getfacilitiy();
    this.getFeatureList();
  },

  computed: {
    getformatClassList() {
      if (this.Facilities.length > 0) {
        return this.Facilities.map((x) => {
          return {
            label: x.name,
            value: x._id,
          };
        });
      } else {
        return [];
      }
    },
  },

  watch: {
    searchWords: function(currentVal, oldVal) {
      let hasCurrentParam = currentVal || "";
      let hasOldParam = oldVal || "";

      if (hasCurrentParam != hasOldParam) {
        this.getAccountList();
      }
    },
  },
  mounted() {
    this.panToMarker();
  },

  methods: {
    calAvg(data){
     //if (!value) return "";
      let totalSum = 0;
      totalSum = data.infrastructure + data.sports + data.facilities + data.management + data.faculty + data.safety  
      let val = (totalSum / 6).toFixed(1);
      return parseFloat(val);

    },
    geolocate() {
      
      navigator.geolocation.getCurrentPosition((position) => {
        
        this.marker.position = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        this.panToMarker();
      });
    },

    handleMarkerDrag(e) {
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
    },

    panToMarker() {
      
      this.$refs.mapRef.panTo(this.marker.position);
    },

    handleMapClick(e) {
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
    },
    async checkMobile() {
      if (this.mobileNo) {
        const phoneNo = Number(this.mobileNo);

        const response = await ViService.viGetOnly(
          `/common/checkApiName?cName=User&phoneNo=${phoneNo}`
        );
        if (response.isSuccess) {
          this.isPhoneNumberAvailable = response.isApiNameAvailable;
        } else {
          this.$toasted.error(response.message);
          if(response.message == 'Your session has expired, please login'){
            localStorage.removeItem('user');
            this.$router.push('/login');
          }
          
        }
      }
    },
      setToClassAndSection(classId) {
      if (classId) {
        const filterByToClass = this.fromClassList.filter((x) => x != classId);
        this.toClassList = filterByToClass;
      } else {
        this.toClassList = [];
        this.schoolDetails.gradeTo = null;
       
      }
    },

     getAddressData(addressData, placeResultData, id) {

      
      this.streetName = addressData.route || "",
      this.state = addressData.administrative_area_level_1 || "",
      this.district = addressData.administrative_area_level_2 || "",
      this.pincode = addressData.postal_code || "";
      this.city = addressData.locality || "";
      
      this.marker.position.lng = addressData.longitude || "";
      this.marker.position.lat = addressData.latitude || "";
      
      this.panToMarker();

      if (this.state) {
        this.state = this.stateList[this.state];
      }

    },
     closeViewPopUp(){
      this.$bvModal.hide("viewPopUp");
     // this.getFeatureList()
    },
    async viewIdea(id,count,index) {
        let details = this.newFeatureList[index]
              
        this.editDetails.status = details.status || '',
        this.editDetails.description = details.description || '',
        this.editDetails.email = details.email || '',
        this.editDetails.viewCount = details.viewCount || 0,
        this.editDetails.stage = details.stage || '',
        this.editDetails.title = details.title || '',
        this.$bvModal.show("viewPopUp");
    },
    // async () {
    //     // let details = this.newFeatureList[index]
              
    //     // this.editDetails.status = details.status || '',
    //     // this.editDetails.description = details.description || '',
    //     // this.editDetails.email = details.email || '',
    //     // this.editDetails.viewCount = details.viewCount || 0,
    //     // this.editDetails.stage = details.stage || '',
    //     // this.editDetails.title = details.title || '',
    // },
    async checkGrandLogin(id) {
      let userData = secureUI.sessionGet("user");

      if (!userData) {
        this.$toasted.error("Please login and do the action");
      } else {
        let requestBody = {
          //expireDay: this.duration,
          accountId: id,
         // branchId: userData.userDetails.branch._id
        };
        const response = await ViService.viXPost(
          `/user/getGrantLoginAccess`,
          requestBody,
          userData.token
        );
        if (response.isSuccess) {
          this.branchList = response.data
         // this.getAccountDetails();
          this.$bvModal.show("viewGRandLoginPopUp");

          //this.$toasted.success(response.message);
        } else {
          this.$toasted.error(response.message);
          if (response.message == "Your session has expired, please login") {
            localStorage.removeItem("user");
            this.$router.push("/login");
          }
        }
      }
    },
    closeGrantpopup(){
      this.branchList = []

      this.$bvModal.hide("viewGRandLoginPopUp");

    },
    
    async submitForm() {
        let userData = secureUI.sessionGet("superAdminuser");

      if (!userData) {
        this.$toasted.error("Please login and do the action");
      } else {
      let isFormValid = false;
      let message = "Please fill all the required details";

      await this.$validator.validateAll("schoolRegister").then((result) => {
        isFormValid = result;
      });


      if (
        isFormValid &&
        this.isEmailIdAvailable &&
        this.isPhoneNumberAvailable &&
        this.isAffiliateIdAvailable
      ) {
        let requestBody = {
          user: {
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.emailID,
            password: this.confirmPassword,
            phoneNo: Number(this.mobileNo),
          },
          accountDetails: {
            accountName: this.schoolName,
            address: this.streetName,
            affilliateId: this.affiliateID,
            state: this.state,
            pincode: this.pincode,
            district: this.district,
            country: this.country,
            email: this.emailID,
            longitude: this.marker.position.lng.toString() || "",
            latitude: this.marker.position.lat.toString() || "",
          },
          type: "schoolAdmin",
        };
        this.streetName
          ? (requestBody.accountDetails["street"] = this.streetName)
          : null;
        this.landlineNo
          ? (requestBody.accountDetails["landlineNo"] = this.landlineNo)
          : null;
        this.viLoader = true;
        ViService.viXPost("/user/admin/createUser", requestBody,userData.token)
          .then((res) => {
            if (res.isSuccess) {
              this.clearForm();
              this.showError = false;
              this.$toasted.success("Registration Successful.Please wait....");
              this.viLoader = null;
              this.$bvModal.hide("modalTwo");
              this.getAccountList();
            } else {
              this.$toasted.error(res.message);
              if(res.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
              }
            }
          })
          .catch((e) => {
            this.viLoader = null;
            let eData = errorLog.apiErrorLog(e);
            this.$toasted.error(eData);
          });
      } else {
        this.$toasted.error(message);
      }
    }
    },
    async deleteCustomerAndAccount(customerId,accountId) {
      let userData = secureUI.sessionGet("superAdminuser");

      this.viLoader = true;

        ViService.viDelete(`/user/delete/${customerId}/${accountId}`,userData.token)
          .then((res) => {
            if (res.isSuccess) {
              this.viLoader = null;
              this.$toasted.success(res.message);
              this.getAccountList();
            } else {
              this.$toasted.error(res.message);
            }
          })
          .catch((e) => {
            this.viLoader = null;
            this.$toasted.error(eData);
          });
    },
    async resetPassword(accountId) {
      this.$toasted.success('Regenerated successfully');
     
    },
    

    async navToSelectedPage(selectedPageNo) {
      this.skip = this.limit * (selectedPageNo - 1);
      this.countAll = false;
      this.getAccountList();
    },

    async goToNextPage() {
      this.countAll = false;
      this.currentPageNumber = this.currentPageNumber + 1;
      this.selected = this.currentPageNumber;
      this.skip = this.limit * (this.currentPageNumber - 1);
      this.getAccountList();
    },

    async goToPreviousPage() {
      this.countAll = false;
      this.currentPageNumber = this.currentPageNumber - 1;
      this.selected = this.currentPageNumber;
      this.skip = this.limit * (this.currentPageNumber - 1);
      this.getAccountList();
    },
    backToHome(){
      this.clearForm()
      this.$bvModal.hide("modalTwo");
      this.district = ""
      this.pincode = ""
      this.city = ""
      this.marker.position.lng = "";
      this.marker.position.lat = "";
    },

    clearForm() {
      this.schoolName = null;
      this.affiliateID = null;
      this.streetName = null;
      this.addressLine = null;
      this.state = null;
      this.country = "India";
      this.firstName = null;
      this.lastName = null;
      this.emailID = null;
      this.websiteURL = null;
      this.landlineNo = null;
      this.mobileNo = null;
      this.password = null;
      this.confirmPassword = null;
      this.$refs.address.$refs.autocomplete.value = ''
    },

    async checkEmail() {
      this.emailID = this.emailID.toLowerCase();

      const response = await ViService.viGetOnly(
        `/common/checkApiName?cName=User&email=${this.emailID}`
      );
      if (response.isSuccess) {
        this.isEmailIdAvailable = response.isApiNameAvailable;
      } else {
        this.$toasted.error(response.message);
         if(response.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
              }
      }
    },

    async checkAffilliateId() {
      const response = await ViService.viGetOnly(
        `/common/checkApiName?cName=Account&affilliateId=${this.affiliateID}`
      );

      if (response.isSuccess) {
        this.isAffiliateIdAvailable = response.isApiNameAvailable;
      } else {
        this.$toasted.error(response.message);
         if(response.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
         }
      }
    },
    async checkEditAffilliateId() {
      const response = await ViService.viGetOnly(
        `/common/checkApiName?cName=Account&affilliateId=${this.schoolDetails.affilliateId}`
      );

      if (response.isSuccess) {
        this.isEditAffiliateIdAvailable = response.isApiNameAvailable;
      } else {
        this.$toasted.error(response.message);
        if(response.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
         }
      }
    },
    async getFeatureList() {
      // let userData = secureUI.sessionGet("superAdminuser");

      // if (!userData) {
      //   this.$toasted.error("Please login and do the action");
      // } else {
         this.viLoader = true
        const response = await ViService.viGetOnly("/app/getFeatureList");
        
        if (response.isSuccess) {
          const details = secureUI.secureGet(response.data);
           if(details.length > 0){
             
            this.newFeatureList = details.filter( x => x.status == 'Under Consideration'),
            this.underConsiderationFeatureList = [],
            this.plannedFeatureList  = details.filter( x => x.status == 'Planned'),
            this.inProgressFeatureList = details.filter( x => x.status == 'In Progress'),
            this.lanuchedFeatureList = details.filter( x => x.status == 'Launched')
          
         }
       } else {
          this.$toasted.error(response.message);
          if(response.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
         }
        }
         this.viLoader = false
     // }
    },

    async getAccountList() {
      this.viLoader = true;
      const response = await ViService.viXGet(
        `/common/getAllSchool/admin?skip=${this.skip}&limit=${this.limit}&search=${this.searchWords}&isCount=${this.countAll}`
      );
      if (response.isSuccess) {
        const resultData = secureUI.secureGet(response.data);
        this.accountList = resultData.accountList;
        if (this.countAll) {
          this.totalCount = resultData.totalCount;
          this.lastPageNumber = Math.ceil(this.totalCount / this.limit);
        }
        this.$toasted.success(response.message);
      } else {
        this.$toasted.error(response.message);
        if(response.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
         }
      }
      this.viLoader = false;
    },

    async getTermsAndConditionsListList() {
      // let userData = secureUI.sessionGet("user");

      // if (!userData) {
      //   this.$toasted.error("Please login and do the action");
      //   this.$router.push("/login");
      // } else {
        var searchWord = "";
        const response = await ViService.viGetOnly(`/app/termsAndConditions/all?skip=0&limit=1000&search=${searchWord}`);
        if (response.isSuccess) {
          this.termsAndConditionsList = secureUI.secureGet(response.data);
          this.$toasted.success(response.message);
        } else {
          this.$toasted.error(response.message);
          if(response.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
         }
        }
      //}
    },

    async getStateList() {
      const response = await ViService.viGetOnly(`/common/fetchStateList`);
      if (response.isSuccess) {
        this.stateList = response.data;
      } else {
        this.$toasted.error(response.message);
      }
    },

    async getAllDistrictsList() {
      const response = await ViService.viGetOnly(`/common/fetchDistrict/all`);
      if (response.isSuccess) {
        this.allDistrictList = response.data;
      } else {
        this.$toasted.error(response.message);
        if(response.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
         }
      }
    },
    async editSchoolDetails(id) {
       let userData = secureUI.sessionGet("superAdminuser");

      const response = await ViService.viXGet(`/account/getSchoolDetail?accountId=${id}`,userData.token);

      if (response.isSuccess) {
        this.schoolDetails = secureUI.secureGet(response.data);

        this.schoolDetails.promoted = this.schoolDetails.promoted ? "Yes" : "No";
      
        if (this.schoolDetails.gradeFrom) {
          this.setToClassAndSection(this.schoolDetails.gradeFrom);
        }

        if (this.schoolDetails.YearOfSchoolEstablishment) {
          this.schoolDetails.YearOfSchoolEstablishment = this.schoolDetails.YearOfSchoolEstablishment.substring(0,10);
        }

        if(this.schoolDetails.schoolAffiliationGranted) {
          this.schoolDetails.schoolAffiliationGranted = this.schoolDetails.schoolAffiliationGranted.substring(0,10);
        }

        this.marker.position.lat = Number(this.schoolDetails.latitude);
        this.marker.position.lng = Number(this.schoolDetails.longitude);  
        this.schoolDetails.isVerified = this.schoolDetails.isVerified ? this.schoolDetails.isVerified : false;

        if(this.schoolDetails.facilities.length > 0) {
          this.schoolDetails.facilities = this.schoolDetails.facilities.map((x) => x._id );
        }

        const res = await ViService.viXGet(`/account/getSchoolFeesDetail?accountId=${id}`,userData.token);

        if(res.isSuccess) {
          this.feesDetails = secureUI.secureGet(res.data);
         
        } else {
          this.$toasted.error(res.message);
          if(res.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
         }
        }
      } else {
        this.$toasted.error(response.message);
      }
      this.getRateingAndReviewList(id)

      this.$bvModal.show("modalOne");
    },
    async getRateingAndReviewList(id){
      let userData = secureUI.sessionGet("superAdminuser");

      if (!userData) {
        this.$toasted.error("Please login and do the action");
         this.$router.push('/login');
      } else {
        // this.viLoader = true;
        const response = await ViService.viXGet(
          `/rating/vidhyaanAdmin/getReviewAndRatings?accountId=${id}`,
          userData.token
        );
        if (response.isSuccess) {
          const resultData = secureUI.secureGet(response.data);
          this.parentReviewList = resultData
        } else {
          this.$toasted.error(response.message);
          if(response.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
         }
        }

       
      }
    },
    closePopUp(){ 
      this.$bvModal.hide("modalOne");
    },


    async openRejectionModal(id,email) {
      this.updateActionId = id,
      this.updateActionMail = email,
      this.schoolEmail = email;
      this.$bvModal.show("modalThree");
    },
    
    async openReviewModal(id) {
      this.schoolReviewId = id

      let userData = secureUI.sessionGet("superAdminuser");

      if (!userData) {
        this.$toasted.error("Please login and do the action");
         this.$router.push('/login');
      } else {
        // this.viLoader = true;
        const response = await ViService.viXGet(
          `/rating/admin/review?accountId=${id}`,
          userData.token
        );
        if (response.isSuccess) {
          const resultData = secureUI.secureGet(response.data);
          
          if(resultData && resultData._id){
            this.recordId = resultData._id
            this.schoolData.infrastructure = resultData.infrastructure,
            this.schoolData.sports = resultData.sports,
            this.schoolData.facilities = resultData.facilities,
            this.schoolData.management = resultData.management,
            this.schoolData.faculty = resultData.faculty,
            this.schoolData.safety = resultData.safety,
            this.adminComments = resultData.vidhyaanComment
          }
          this.$toasted.success(response.message);
        } else {
          this.$toasted.error(response.message);
           if(response.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
         }
        }

       
      }

      this.$bvModal.show("reviewModel");
    },
    async saveAdminReview(){
      let userData = secureUI.sessionGet("superAdminuser");
      if (!userData) {
        this.$toasted.error("Please login and do the action");
         this.$router.push('/login');
      } else {
        this.$toasted.clear();
       
        
          let requestBody = {
            accountId: this.schoolReviewId,
            infrastructure: this.schoolData.infrastructure,
            sports: this.schoolData.sports,
            facilities: this.schoolData.facilities,
            management: this.schoolData.management,
            faculty: this.schoolData.faculty,
            safety: this.schoolData.safety,
            comment: '',
            schoolName: "",
            isReviewedByAdmin: true,
            isReviewedByParent: false,
            category: "",
            city: "",
            status: 'Submitted',
            vidhyaanComment: this.adminComments
          };

            const response = await ViService.viXPost(
            "/rating/save/vidhyaanadmin",
            requestBody,
            userData.token
          );


          if (response.isSuccess) {
                this.closeReviewModal();
                this.$toasted.success("Rating submitted successfully");
          } else {
            
            this.$toasted.error(response.message);
             if(response.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
         }
          }
       
      }
    },
    closeReviewModal(){
      this.schoolReviewId = null
      this.schoolData.infrastructure = 0  
      this.schoolData.sports = 0  
      this.adminComments = ''
      this.schoolData.facilities = 0  
      this.schoolData.management = 0  
      this.schoolData.faculty = 0  
      this.schoolData.safety = 0  
      this.recordId = null
      this.$bvModal.hide("reviewModel");
    },
    async updateRating() {
      let userData = secureUI.sessionGet("superAdminuser");

      if (!userData) {
        this.$toasted.error("Please login and do the action");
        this.$router.push('/login');
      } else {
        this.$toasted.clear();
       

          let requestBody = {
            schoolName: this.parentReviewDetails.schoolName,
            parentName: this.parentReviewDetails.parentName,
            parentEmail:this.parentReviewDetails.parentEmail,
            status : this.parentReviewDetails.status,
            vidhyaanComment: this.parentReviewDetails.vidhyaanComment
          };

            const response = await ViService.viXPost(
            `/rating/updateReview/admin/${this.parentReviewDetails._id}`,
            requestBody,
            userData.token
          );


          if (response.isSuccess) {
                this.getRateingAndReviewList(this.parentReviewDetails.accountId)
                this.$toasted.success("Rating updated successfully");
                this.closeReviewParentModal()
          } else {
            
            this.$toasted.error(response.message);
             if(response.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
             }
          }
       
      }
    },
     async openReviewParentModel(index) {
        let details = this.parentReviewList[index]
        this.parentReviewDetails = details

        this.parentReview.infrastructure = details.infrastructure ? details.infrastructure : 0,
        this.parentReview.sports = details.sports ? details.sports : 0,
        this.parentReview.facilities = details.facilities ? details.facilities : 0,
        this.parentReview.management = details.management ? details.management : 0,
        this.parentReview.faculty = details.faculty ? details.faculty : 0,
        this.parentReview.safety = details.safety ? details.safety : 0,
     
      this.$bvModal.show("reviewParentModel");
     
    },
    closeReviewParentModal(){
      this.$bvModal.hide("reviewParentModel");
    },
    

    async closeCreationScreen() {
      this.$bvModal.hide("modalTwo");
    },

    async closeModal() {
      this.$bvModal.hide("modalOne");
      this.$bvModal.hide("modalThree");
    },
    closeRejectModal(){
      this.updateActionId = null,
      this.updateActionMail = '',
      this.$bvModal.hide("modalThree");
    },
     closeActionPopUp(){
      this.$bvModal.hide("actionApprovePopup");
      this.updateActionId = null,
      this.updateActionMail = ''
    },
    openApproveModel(id,mail){
      this.updateActionId = id,
      this.updateActionMail = mail,
      this.$bvModal.show("actionApprovePopup");
    },

    async enableReadView(id) {
      this.isEdit = true;
      this.editSchoolDetails(id);
      this.getPlanAndSubscriptionDetails(id);
    },

    async enableWriteView(id) {
      this.isEdit = false;
      this.editSchoolDetails(id);
      this.getPlanAndSubscriptionDetails(id);
    },
    viewSubscriptionDetails(index){
      const details = this.subscriptions[index]
      
      this.planDetails = details
      this.$bvModal.show("showSubscriptionPopUp");
    },
    closePoup(){
      this.$bvModal.hide("showSubscriptionPopUp");
    },
    async getPlanAndSubscriptionDetails(id) {
      let userData = secureUI.sessionGet("superAdminuser");

      if (!userData) {
        this.$toasted.error("Please login and do the action");
      } else {
        const response = await ViService.viXGet("/account/getPlanDetails?accountId=" + id,userData.token);
        if (response.isSuccess) {
          
          this.subscriptions = response.data.subscriptions || []
          this.invoiceDetails = response.data.invoiceDetails || []
          this.createdStudent = response.data.createdStudentsCount || 0
        } else {
          this.$toasted.error(response.message);
           if(response.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
         }
        }
      }
    },

    async enableEditView() {
      this.isEdit = !this.isEdit;
    },

    async openRejectConfirmation() {
      this.$bvModal.show("modalThree");
    },

    async updateDetails() {

       let isFormValid = false;
      let message = "Please fill all the required details";

      await this.$validator.validateAll("schOverview").then((result) => {
        isFormValid = result;
      });
      if (isFormValid && this.isEditAffiliateIdAvailable) {
        let userData = secureUI.sessionGet("superAdminuser");

        if (!userData) {
          this.$toasted.error("Please login and do the action");
          this.$router.push("/login");
        } else {
           const response = await ViService.viXPut(
          `/account/`,
          this.schoolDetails,userData.token
        );
        if (response.isSuccess) {
          this.$toasted.success("School Updated Successfully!");
          this.getAccountList();
          this.$bvModal.hide("modalOne");
        } else {
          this.$toasted.error(response.message);
           if(response.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
         }
        }
        
        }
      } else {
        this.$toasted.error(message);
      }

     // let userData = secureUI.sessionGet("user");

      // if (this.isEditAffiliateIdAvailable) {
      //   const response = await ViService.viXPut(
      //     `/account/`,
      //     this.schoolDetails,userData.token
      //   );
      //   if (response.isSuccess) {
      //     this.$toasted.success("School Updated Successfully!");
      //     this.getAccountList();
      //   } else {
      //     this.$toasted.error(response.message);
      //   }
      //   this.$bvModal.hide("modalOne");
      // } else {
      //   this.$toasted.error("Please fill all the required details");
      // }
    },

    async actionConfirm() {
      let userData = secureUI.sessionGet("superAdminuser");

      let obj = {
        id: this.updateActionId,
        mail: this.updateActionMail,
      }

      const response = await ViService.viXPut(`/account/verify`,obj,userData.token);
      if (response.isSuccess) {
        this.$toasted.success("School Approved Successfully!");
        this.closeActionPopUp();
        this.getAccountList();
      } else {
        this.$toasted.error("Something went wrong!");
      }
      this.$bvModal.hide("modalOne");
    },

    async sendRejectionMail() {
      let userData = secureUI.sessionGet("superAdminuser");

      let obj = {
        id: this.updateActionId,
        mail: this.updateActionMail,
        reason: this.reason
      }

      const response = await ViService.viXPut(`/account/reject`, obj,userData.token);
      if (response.isSuccess) {
        this.$toasted.success(response.message);
        this.closeRejectModal()
        this.getAccountList(); 
      } else {
        this.$toasted.error(response.message);
      }
      this.$bvModal.hide("modalOne");
    },

    async navToGrandLogin() {},

    async getfacilitiy() {
      //let userData = secureUI.sessionGet("user");

      const response = await ViService.viGetOnly("/app/getFacilitiyList");
      if (response.isSuccess) {
        this.Facilities = secureUI.secureGet(response.data);
      } else {
        this.$toasted.error(response.message);
         if(response.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
         }
      }
    },

    async openSchoolCreationModal() {
      this.$bvModal.show("modalTwo");
    },

    async enableTermsAndConditionsView() {
      this.schoolView = false;
      this.termsAndConditionsView = true;
      this.featureRequestView = false
    },

    async enableSchoolView() {
      this.termsAndConditionsView = false;
      this.schoolView = true;
      this.featureRequestView = false
    },
    async enableFeatureRequestView() {
      this.termsAndConditionsView = false;
      this.schoolView = false;
      this.featureRequestView = true
    },
    

    async proceedToPayment() {
      const response = await order(100);
    },

    async updateSchoolLogo(type, docType) {
      let userData = secureUI.sessionGet("superAdminuser");

      if (!userData) {
        this.$toasted.error("Please login and do the action");
      } else {
        const docFileDetails = this.$refs[docType].files[0];
        const fd = new FormData();
        fd.append(
          "doc",
          docFileDetails,
          docFileDetails.name,
          docFileDetails.actType
        );
        const response = await ViService.viPutOnly(
          `/document/uploadFile/${this.schoolDetails._id}/${type}`,
          fd,
          userData.token
        );
        if (response.isSuccess) {
          this.$toasted.success(response.message);
          this.editSchoolDetails(this.schoolDetails._id);
          this.$bvModal.hide("imagePopup");
        } else {
          this.$toasted.error(response.message);
           if(response.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
         }
        }
      }
    },

    async updateFile(type, docType) {
      let userData = secureUI.sessionGet("superAdminuser");

      if (!userData) {
        this.$toasted.error("Please login and do the action");
      } else {
        const docFileDetails = this.$refs[docType].files[0];
        const fd = new FormData();
        fd.append(
          "doc",
          docFileDetails,
          docFileDetails.name,
          docFileDetails.actType
        );

        const response = await ViService.viPutOnly(
          `/document/uploadTermsAndConditionDocument`,
          fd,
          userData.token
        );
        if (response.isSuccess) {
          this.$toasted.success(response.message);
        } else {
          this.$toasted.error(response.message);
           if(response.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
         }
        }
      }
    },

    // async updateCSVFile(type) {
    //   const docFileDetails = this.$refs[type].files[0];
    //   const fd = new FormData();
    //   const response = await convert(docFileDetails);
    // },

    redirectRoute(vipath) {
      if (this.$route.path !== vipath) this.$router.push({ path: vipath });
    },

    redirectCustomRoute(accountDetails,branchDetails) {
    //   let accountDetails = this.$route.query.accountId
    //  let branchDetails = this.$route.query.branchId

   if (accountDetails) {
    
      let requestBody = {
        accountId: accountDetails,
        branchId: branchDetails
      };
      ViService.viPost("/auth/grandLoginUser/signin", requestBody)
        .then((res) => {
          if (res.isSuccess) {
              this.invalidToken = true   
              localStorage.setItem("newUserToken", res.data);
              let userData = secureUI.sessionGet("newUserToken");
             let appUrl = 'https://admin--stage.vidhyaan.com'

             let newUrl = appUrl + `?token=${encodeURIComponent(res.data).trim()}`;
             window.open(newUrl, '_blank');

          }else {
             // this.invalidToken = false   
              this.$toasted.error(res.message);
                  
          } 
         
        })
        .catch((e) => {
            this.invalidToken = false   
          this.$toasted.error(e);
        });
    }
  
     
     // window.open(`http://localhost:8080${vipath}`);
    },

    logout() {
       let userData = secureUI.sessionGet("superAdminuser");
          ViService.viPost("/auth/logout", {_id: userData.userDetails._id })
            .then((res) => {
              if (res.isSuccess) {
          this.$store.dispatch("setIndividualSchoolInfo",{});
          this.$store.dispatch("setCurrentPlanDetail",{});
          this.$store.dispatch('setOurServiceActiveLink', '');
          this.$store.dispatch('setUserDetail', {});

          this.$store.dispatch("setAdmissionObjCOunt",{
            academicYear: 0,
            admission: 0,
            class: 0,
            departMent: 0,
            student: 0,
            teacher: 0,
            schoolType: 0,
            admins: 0,
            section: 0,
            subject: 0

          });
          this.$store.dispatch("setEnrollObjCOunt",{
    
            academicYear: 0,
            admission: 0,
            class: 0,
            onlineAdmission: 0,
            isVerified: false
          });
          this.$store.dispatch("setFeesManagementObjCount",{
            feeType : 0,
            feesPlan : 0,
            adhocFees : 0,
            assignedFeesType : 0,
            discountsAndPenalties : 0,
            feesPlanGenerated: 0
          });
           this.$store.dispatch('setFetchAdmissionObjCount',false)
          this.$store.dispatch("setFetchFeesObjCount",false);
          this.$store.dispatch("setFetchEnrollObjCount",false);
        
          localStorage.removeItem('user');
          localStorage.removeItem('superAdminuser');
          // this.$router.push('/');
          window.location.href = process.env.VUE_APP_REDIRECT_URL;
          
              } else {
               this.$toasted.error(res.message);
              }
            })
            .catch((e) => {
            
              this.$toasted.error(eData);
            });

         
          // location.reload();
    },

    isActive(menuItem) {
      return this.activeItem === menuItem;
    },

    setActive(menuItem) {
      this.activeItem = menuItem;
    },

    async getPincodeList(districtId) {
      this.pincodeList = [];
      if (districtId) {
        const codeList = this.districtList.find((x) => x._id == districtId);
        if (codeList) {
          if (codeList.pinCode.length == 1) {
            this.pincode = codeList.pinCode[0];
          }
          this.pincodeList = codeList.pinCode;
        }
      }
    },

    async getDistrictList(id) {
      if (id) {
        const response = await ViService.viGetOnly(
          `/common/fetchDistrictList?stateId=${id}`
        );
        if (response.isSuccess) {
          this.districtList = response.data;
        } else {
          this.$toasted.error(response.message);
           if(response.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
         }
        }
      } else {
        this.districtList = [];
      }
    },

    sumAmount(amountList) {
      let sum = 0;
      amountList.forEach((x) => {
        sum += x.totalAmount;
      });
      return sum;
    },

    async navToMeeting() {
      this.$router.push("/meet");
    },

    async createRoom() {
      const domain = "meet.jit.si";
      const options = {
        roomName: "PickAnAppropriateMeetingNameHere",
        width: 700,
        height: 700,
        parentNode: document.querySelector("#meet"),
      };
      const api = new JitsiMeetExternalAPI(domain, options);
    },
  },

  filters: {
    removeURLPrefix: function(value) {
      if (!value) return "";
      value = value.trim();
      return value.replace(/(^\w+:|^)\/\//, "");
    },
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    },
    averageRating: function(value) {
      if (!value) return "";
      let totalSum = 0;
      for (let key in value) {
        if (value.hasOwnProperty(key)) {
          totalSum += value[key];
        }
       
      }
     
      let val = (totalSum / 6).toFixed(1);
      return parseFloat(val);

     // const customTermsCount = Math.round(fixedOneDecimal)

    //  return Math.round(val);
    },
  },
};
</script>

<style lang="scss" scoped>
.vi-r-review,
.vi-w-review {
  display: inline-block;
}
</style>